export default {
  "Dashboard": "Dashboard",
  "Products": "Products",
  "Order": "Order",
  "Stores": "Stores",
  "Service Ticket": "Service Ticket",
  "Pre-order Inventory": "Pre-order Inventory",
  "Third Bound Goods": "Third Bound Goods",
  "Withdrawal List": "Withdrawal List",
  "My Profile": "My Profile",
  "Import List": "Import List",
  "My Products": "My Products",
  "Quotation": "Quotation",
  "Payment": "Payment",
  "Shipments": "Shipment",
  "Shipment": "Tracking Code",
  "Abnormal": "Abnormal",
  "Completed": "Completed",
  "On Hold": "On Hold",
  "Canceled": "Canceled",
  "All": "All",
  "Support": "Support",

  "Announcement": "Announcement",
  "balance": "Balance",
  "View Detail": "View Detail",
  "wallet": "wallet",
  "commission": "Commission",
  "withdraw": "withdraw",
  "system notification": "system notification",
  "Order Quantity": "Order Quantity",
  "Commission": "Commission",
  "Total commission": "Total commission",
  "This month Orders": "This month Orders",
  "This month Revenue": "This month Revenue",
  "This month Cost": "This month Cost",
  "Statistics": "Statistics",
  "Reference": "Reference",
  "Date": "Date",
  "Total Orders": "Total Orders",
  "Cost": "Cost",
  "Show More": "Show More",
  "Quick Summary": "Quick Summary",
  "orders": "orders",
  "Waiting to place order": "Waiting to place order",
  "Waiting for tracking code": "Waiting for tracking code",
  "Authorized": "Authorized",
  "Share by APP": "Share by APP",
  "Share": "Share",
  "Scan share to WeChat": "Scan share to WeChat",
  "Share by link": "Share by link",
  "Share link": "Share link",
  "Copy Link": "Copy Link",
  "Clear": "Clear",
  "Close": "Close",
  "Your vendor": "Your vendor",
  "is inviting you to allocate your Orders": "is inviting you to allocate your Orders",
  "Your store name": "Your store name",
  "Dispatch order method": "Dispatch order method",
  "All my unfulfilled / partially fulfilled orders": "All my unfulfilled / partially fulfilled orders",
  "Cycle time": "Cycle time",
  "Every 1 day": "Every 1 day",
  "You can modify your order dispatch rules at any time in the menu 'My Orders >> Dispatch settings": "You can modify your order dispatch rules at any time in the menu 'My Orders >> Dispatch settings",
  "Remind later": "Remind later",
  "I agree": "I agree",
  "According to your settings, we found some data for you": "According to your settings, we found some data for you",
  "Shopify order": "Shopify order",
  "Dispatch in the Next Cycle": "Dispatch in the Next Cycle",
  "Dispatch Immediately": "Dispatch Immediately",
  "Revenue": "Revenue",
  "You can modify your store settings at any time in the menu 'My Stores'": "You can modify your store settings at any time in the menu 'My Stores'",
  "Newbie": "Newbie",
  "Guide": "Guide",
  "Complete personal information": "Complete personal information",
  "Authorize to bind the store": "Authorize to bind the store",
  "Publish the push product": "Publish the push product",
  "Start pulling orders": "Start pulling orders",
  "Already": "Already",
  "enter": "enter",
  "offline": "offline",
  "success": "success",
  "Add vendors success": "Add vendors success",
  "Total Revenue": "Total Revenue",
  "Total Cost": "Total Cost",
  "Has been copied to the clipboard": "Has been copied to the clipboard",
  "Copy to clipboard failed, please copy manually": "Copy to clipboard failed, please copy manually",

  "Waiting": "Waiting",
  "Processing": "Processing",
  "Failed": "Failed",
  "Are you sure you want to push?": "Are you sure you want to push?",
  "Do you want to delete this task?": "Do you want to delete this task?",
  "The update  has started, it will take a while to finish.": "The update  has started, it will take a while to finish.",
  "Do you want to delete the product?": "Do you want to delete the product?",
  "Do you want to Export the product?": "Do you want to Export the product?",
  "Export success": "Export success",
  "Please select the products": "Please select the products",
  "URL required": "URL required",
  "Import success": "Import success",
  "Please select the tags": "Please select the tags",
  "Tags added successfully": "Tags added successfully",
  "You can import and manage your AliExpress / Amazon products here before publishing them to your Shopify store. You can publish a product to different stores and add multiple tags to each products.": "You can import and manage your AliExpress / Amazon products here before publishing them to your Shopify store. You can publish a product to different stores and add multiple tags to each products.",
  "Import Aliexpress": "Import Aliexpress",
  "Import Product": "Import Product",
  "Product Name": "Product Name",
  "Product Type": "Product Type",
  "Product Pictures": "Product Pictures",
  "Gross weight for each Carton": "Gross weight for each Carton",
  "Carton Package Size L": "Carton Package Size L",
  "Carton Package Size W": "Carton Package Size W",
  "Carton Package Size H": "Carton Package Size H",
  "Single Price": "Single Price",

  "All Stores": "All Stores",
  "Filter": "Filter",
  "Push": "Push",
  "Export": "Export",
  "Delete": "Delete",
  "Add Tags": "Add Tags",
  "Tag management": "Tag management",
  "Confirm": "Confirm",
  "Push Setting": "Push Setting",
  "Upload Progress": "Upload Progress",
  "Status": "Status",
  "Images": "Images",
  "Sold Out": "Sold Out",
  "Store Name": "Store Name",
  "Price": "Price",
  "Supply Unit Price": "Supply Unit Price",
  "Your Price": "Your Price",
  "Fail Reason": "Fail Reason",
  "Edit": "Edit",
  "Open in Web": "Open in Web",
  "no product": "no product",
  "All Action": "All Action",
  "price check": "price check",
  "add related products": "add related products",
  "Open in  website": "Open in  website",
  "Retail price": "Retail price",
  "Supplier price": "Supplier price",
  "NOT SET": "NOT SET",
  "Shopify store": "Shopify store",
  "vendors": "vendors",
  "You can only upload 5 pictures": "You can only upload 5 pictures",
  "Price units default to": "Price units default to",
  "Please upload pictures": "Please upload pictures",
  "Please enter title": "Please enter title",
  "Please enter price": "Please enter price",
  "Are you sure you want to delete it?": "Are you sure you want to delete it?",

  "Order Management": "Order Management",
  "Waiting For Quote": "Not Quoted yet",
  "Pay All": "Pay All",
  "SKU number/quantity/name": "SKU number/quantity/name",
  "Update Order": "Refresh",
  "Export Order": "Export Order",
  "Import Order": "Import Order",
  "Import Product Image": "Import Product Image",
  "Order Number": "Order Number",
  "Customer": "Customer",
  "Payment Number": "Payment Number",
  "Today": "Today",
  "Create Quotation": "Create Quotation",
  "Abandon Quotation": "Abandon Quotation",
  "Bulk Payment": "Bulk Payment",
  "Cancel Payment": "Cancel Payment",
  "Manually Sync": "Manually Sync",
  "Continue Pay": "Continue Pay",
  "Requote": "Requote",
  "Product Images": "Product Images",
  "Unable to be sourced": "Unable to be sourced",
  "Please make an offer": "Please make an offer",
  "Attribute Value": "Attribute Value",
  "Supplier Price": "Supplier Price",
  "Retail Price": "Retail Price",
  "Action": "Action",
  "Remove": "Remove",
  "offline order": "offline order",
  "Wholesale order": "Wholesale order",
  "Order No.": "Order No.",
  "Created Date": "Created Time",
  "Shipping Address": "Shipping Address",
  "Shipping Method": "Shipping Method",
  "Free Shipping": "Free Shipping",
  "Shipping Cost": "Shipping Cost",
  "Total": "Total",
  "Pay Total": "Pay Total",
  "Quote": "Quote",
  "Pay": "Pay",
  "Split Order": "Split Order",
  "After-sales": "After-sales",
  "Cancel Order": "Cancel Order",
  "Sku/Quantity/Name": "Sku/Quantity/Name",
  "Payment No.": "Payment No.",
  "Payment Time": "Payment Time",
  "Amount": "Amount",
  "Countdown": "Countdown",
  "Quantity": "Quantity",
  "Repay": "Repay",
  "To Complete Payment": "To Complete Payment",
  "Supplier Unit Price": "Supplier Unit Price",
  "Removed": "Removed",
  "Shipping Type": "Shipping Type",
  "LOGISTICS": "LOGISTICS",
  "SELF PICKUP": "SELF PICKUP",
  "PREPURCHASE": "PREPURCHASE",
  "Order ID": "Order ID",
  "Recover": "Recover",
  "RecoverAll": "RecoverAll",
  "Pay with": "Pay with",
  "Bonus": "Bonus",
  "There is no alternative method of payment": "There is no alternative method of payment",
  "Please do not close the page during payment": "Please do not close the page during payment",
  "Close pay": "Close pay",
  "Your order has been successfully paid": "Your order has been successfully paid",
  "The selected orders are abnormal and payment cannot be continued": "The selected orders are abnormal and payment cannot be continued",
  "Payment can continue after excluding the following goods": "Payment can continue after excluding the following goods",
  "After removing the off shelf goods, the order will be returned to the": "After removing the off shelf goods, the order will be returned to the",
  "price to be quoted": "price to be quoted",
  "Select file": "Select file",
  "Click to download": "Click to download",
  "Order Import Template": "Order Import Template",
  "Please fill in the form according to the specification, only xlsx format files are supported": "Please fill in the form according to the specification, only xlsx format files are supported",
  "The uploaded file cannot exceed 2M, and only the first 99 data are processed": "The uploaded file cannot exceed 2M, and only the first 99 data are processed",
  "submit": "submit",
  "Created At": "Created At",
  "Cancel": "Cancel",
  "Waiting for quotation": "Waiting for quotation",
  "Supplier Quote": "Supplier Quote",
  "Payment Not Received": "Payment Not Received",
  "Pending payment": "Pending payment",
  "Unshipped": "Unshipped",
  "Fulfilled": "Fulfilled",
  "Logistics sync failed": "Logistics sync failed",
  "Unable to purchase": "Unable to purchase",
  "Products off shelf": "Products off shelf",
  "Payment unfinished": "Payment unfinished",
  "Payment to be completed": "Payment to be completed",
  "Waiting for fulfill": "Unshipped",
  "Quit quotation": "Quit quotation",
  "Payment failed": "Payment failed",
  "Vendor Verifying Payment": "Vendor Verifying Payment",
  "Payment result to be returned": "Payment result to be returned",
  "Remove the product": "Remove the product",
  "Removed the product successful": "Removed the product successful",
  "Delete Successful": "Delete Successful",
  "Please select an order first": "Please select an order first",
  "Sure to delete this item?": "Sure to delete this item?",
  "Delete Successful!": "Delete Successful!",
  "Please select an order": "Please select an order",
  "Please choose file": "Please choose file",
  "Create Success": "Create Success",
  "No goods need to be eliminated": "No goods need to be eliminated",
  "No logistics": "No logistics",
  "Are you sure to abandon payment for the selected order? After abandoning, the order will disappear from the list, which cannot be restored, please operate with caution": "Are you sure to abandon payment for the selected order? After abandoning, the order will disappear from the list, which cannot be restored, please operate with caution",
  "No Purchase": "Quote Cancelled",
  "Unpaid Order": "Ready to Pay",
  "Payment Initiated but Unpaid": "Payment Initiated but Unpaid",
  "Payment Made but Not Received": "Payment Made but Not Received",
  "The receiving address has no logistics method set": "The receiving address has no logistics method set",
  "The order is below the minimum deliverable weight": "The order is below the minimum deliverable weight",
  "The order is below the minimum deliverable volume": "The order is below the minimum deliverable volume",
  "The order is higher than the maximum deliverable weight": "The order is higher than the maximum deliverable weight",
  "The order is higher than the maximum deliverable volume": "The order is higher than the maximum deliverable volume",
  "The following product attributes of this order do not meet the attribute requirements of deliverable products": "The following product attributes of this order do not meet the attribute requirements of deliverable products",
  "The total weight of the goods in this order does not meet the deliverable requirements": "The total weight of the goods in this order does not meet the deliverable requirements",
  "Weight": "Weight",
  "Total weight": "Total weight",
  "Attribute": "Attribute",
  "I Know": "I Know",
  "Card Number": "Card Number",
  "Expiration": "Expiration",
  "Payment amount": "Payment amount",
  "Payment instructions": "Payment instructions",
  "Other details": "Other details",
  "Payment account": "Payment account",
  "Payment voucher": "Payment voucher",
  "Add Tracking": "Add Tracking",
  "Track number": "Track number",
  "Please input the tracking number": "Please input the tracking number",
  "Track company": "Track company",
  "Your request has been sent": "Your request has been sent",

  "My Stores": "My Stores",
  "Add a new store": "Add a new store",
  "Creation date": "Creation date",
  "Auth date": "Auth date",
  "Remove entrusted vendor": "Remove entrusted vendor",
  "Reauthorize": "Reauthorize",
  "Coming Soon": "Coming Soon",
  "vendor is authorizing the store on BCNDropshipping App, please be noted.": "vendor is authorizing the store on BCNDropshipping App, please be noted.",
  "If you do not check the relevant permissions, it will affect the use of related functions, please operate with caution": "If you do not check the relevant permissions, it will affect the use of related functions, please operate with caution",
  "Connect": "Connect",
  "Are you sure you want to cancel the hosting store": "Are you sure you want to cancel the hosting store",
  "after you close the hosting, the supplier will not be able to actively quote your order!": "after you close the hosting, the supplier will not be able to actively quote your order!",
  "Sure": "Sure",
  "You have successfully hosted the store": "You have successfully hosted the store",
  "After the successful hosting, your supplier will take the initiative to quote for your pending orders!": "After the successful hosting, your supplier will take the initiative to quote for your pending orders!",
  "Choose a vendor": "Choose a vendor",
  "Select": "Select",
  "No Data": "No Data",
  "Save": "Save",
  "Add a new vendor": "Add a new vendor",
  "Customer name required": "Customer name required",
  "customers successfully added": "customers successfully added",
  "Are you sure you want to remove entrusted vendor?": "Are you sure you want to remove entrusted vendor?",

  "After-sales Ticket": "After-sales Ticket",
  "Ticket Type": "Ticket Type",
  "Customer Name": "Customer Name",
  "Approval": "Approval",
  "Transaction Type": "Transaction Type",
  "Question Type": "Question Type",
  "Problem Description": "Problem Description",
  "Refund": "Refund",
  "Replacement": "Replacement",
  "modify the related information for customer": "modify the related information for customer",
  "cancel order": "cancel order",
  "No tracking information": "No tracking information",
  "Tracking information not update too long time": "Tracking information not update too long time",
  "Item damage": "Item damage",
  "Item missing": "Item missing",
  "Send wrong product": "Send wrong product",
  "Send wrong address": "Send wrong address",
  "On hold order": "On hold order",
  "optional": "optional",
  "Order Information": "Order Information",
  "Third party order number": "Third party order number",
  "Creation time": "Creation time",
  "On Hold Order": "On Hold Order",
  "Resend Item": "Resend Item",
  "Refund Item": "Refund Item",
  "agree": "agree",
  "Ticket No.": "Ticket No.",
  "please enter": "please enter",
  "Approval Status": "Approval Status",
  "Await Review": "Await Review",
  "Reject": "Reject",
  "Pass": "Pass",
  "Missing Item": "Missing Item",
  "Wrong Product": "Wrong Product",
  "Modify the related information for customer": "Modify the related information for customer",
  "Change color/size": "Change color/size",
  "Change Product": "Change Product",
  "Payment Issues": "Payment Issues",
  "Voucher": "Voucher",

  "Transaction": "Transaction",
  "normal bill": "normal bill",
  "Create Time": "Create Time",
  "Yesterday": "Yesterday",
  "Last 7 days": "Last 7 days",
  "Payment Code": "Payment Code",
  "Third Party Number": "Third Party Number",
  "Trade type": "Trade type",
  "Trade status": "Trade status",
  "Account payee": "Account payee",
  "Order number": "Order number",
  "Remark": "Remark",
  "Trade amount": "Trade amount",
  "Payment type": "Payment type",
  "Operate": "Operate",
  "abnormal bill": "abnormal bill",
  "View detail": "View detail",
  "download PDF": "download PDF",
  "The export of time": "The export of time",
  "Petitioner": "Petitioner",
  "Payment order": "Payment order",
  "Refund order": "Refund order",
  "Wallet card": "Wallet card",
  "Manual deduction": "Manual deduction",
  "Paying": "Paying",
  "Account paid": "Account paid",
  "Refunded": "Refunded",
  "Invoice Pay":"Order Pay",
  "Refund Order":"Order Refund",
  "Bonus Recharge":"Bonus Recharge",
  "Bonus Deduction":"Bonus Deduction",
  "unpaid":'Pending',
  "paid":"Paid",
  "refund":"Refund",
  "canceled":"Canceled",

  "Pre-order stock order": "Pre-order stock order",
  "pleaseCusName": "pleaseCusName",
  "Withdrawal list": "Withdrawal list",
  "Withdrawal method": "Withdrawal method",
  "CreateDate": "CreateDate",
  "startDate": "StartDate",
  "endDate": "EndDate",
  "accountPayee": "accountPayee",
  "customersName": "customersName",
  "Warning Tips": "Warning Tips",
  "Withdrawal Amount": "Withdrawal Amount",
  "reject": "reject",
  "Pending": "Pending",
  "Approved": "Approved",
  "GENERAL INFORMATION": "GENERAL INFORMATION",
  "CONTACT": "CONTACT",
  "Change": "Change",
  "ADD": "ADD",
  "SOCIAL": "SOCIAL",
  "Notification Settings": "Notification Settings",
  "I want to receive notfications by": "I want to receive notfications by",
  "Mobile phone": "Mobile phone",
  "Allow system notifhcations": "Allow system notifhcations",
  "Allow Customer Services from": "Allow Customer Services from",
  "Allow Dropshipping News": "Allow Dropshipping News",
  "Reset All": "Reset All",
  "Save Changes": "Save Changes",
  "try again in": "try again in",
  "seconds": "seconds",
  "Discard": "Discard",

  "Login/Register": "Login/Register",
  "Logout": "Logout",
  "Powered by COMEXBCN-BCN DROPSHIPPING": "Powered by COMEXBCN-BCN DROPSHIPPING",
  "Home": "Home",
  "PRIVACY POLICY": "PRIVACY POLICY",
  "SHIPPING POLICY": "SHIPPING POLICY",
  "TERMS AND CONDITIONS OF USE": "TERMS AND CONDITIONS OF USE",
  "RETURN AND REFUND POLICY": "RETURN AND REFUND POLICY",
  "CONTACT US": "CONTACT US",
  "Category Name": "Category Name",
  "More": "More",
  "Product category name": "Product category name",
  "Waiting for the payment result to be returned.": "Waiting for the payment result to be returned.",
  "You may need to wait a little while": "You may need to wait a little while",
  "Payment successful": "Payment successful",
  "You have successfully completed your order": "You have successfully completed your order",
  "View order": "View order",
  "Sorry, we can't complete the payment.": "Sorry, we can't complete the payment.",
  "Add New Address": "Add New Address",
  "Product Details": "Product Details",
  "Please check the purchase produc": "Please check the purchase produc",
  "out of stock": "out of stock",
  "Inventory": "Inventory",
  "Subtotal": "Subtotal",
  "Freight": "Freight",
  "Credits": "Credits",
  "Combination payment": "Combination payment",
  "Please enter the balance to be used": "Please enter the balance to be used",
  "Rules: The input amount should be less than the order amount, and only two decimal places": "Rules: The input amount should be less than the order amount, and only two decimal places",
  "Payment method": "Payment method",
  "Amount due (including freight)": "Amount due (including freight)",
  "Submit orders": "Submit orders",
  "Please select payment method": "Please select payment method",
  "First Name": "First Name",
  "Please enter the first name": "Please enter the first name",
  "Last Name": "Last Name",
  "Please enter the last name": "Please enter the last name",
  "Please enter the address": "Please enter the address",
  "Please enter the country": "Please enter the country",
  "Please enter the province": "Please enter the province",
  "Please enter the city": "Please enter the city",
  "Please enter the phone": "Please enter the phone",
  "Please enter the postcode": "Please enter the postcode",
  "Set as default shipping address": "Set as default shipping address",
  "Reset": "Reset",
  "Search Product": "Search Product",
  "History": "History",
  "Publish": "Publish",
  "No Account?": "No Account?",
  "Sign up here": "Sign up here",
  "Sign in": "Sign in",
  "Forgot your password?": "Forgot your password?",
  "or Sign in with": "or Sign in with",
  "Already have an account?": "Already have an account?",
  "Products Market": "Products Market",
  "Unit Price": "Unit Price",
  "GO": "GO",
  "Qty Available": "Qty Available",
  "First Available": "First Available",
  "Last 14 days": "Last 14 days",
  "Last 30 days": "Last 30 days",
  "Sort by": "Sort by",
  "There are no products in this category": "There are no products in this category",
  "Please enter your shopify store name to connect the dashboard page": "Please enter your shopify store name to connect the dashboard page",
  "Stock Qty": "Stock Qty",
  "VAT information": "VAT information",
  "you can click": "you can click",
  "for VAT information": "for VAT information",
  "Shipping": "Shipping",
  "Shipping to": "Shipping to",
  "Please select": "Please select",
  "Shipping fee": "Shipping fee",
  "Quality": "Quality",
  "inventory": "inventory",
  "Add to List": "Add to List",
  "Add to Cart": "Add to Cart",
  "Specifications": "Specifications",
  "Download the attachment": "Download the attachment",
  "product information": "product information",
  "Product category": "Product category",
  "product name": "product name",
  "Specification": "Specification",
  "material": "material",
  "size": "size",
  "weight": "weight",
  "The tax-inclusive price of an item is calculated based on the item price set by the seller and the applicable tax rate. You can contact the seller for more details.": "The tax-inclusive price of an item is calculated based on the item price set by the seller and the applicable tax rate. You can contact the seller for more details.",
  "You have authorized a Shopify store，you could": "You have authorized a Shopify store，you could",
  "to view details": "to view details",
  "authorize to login": "authorize to login",
  "If it is necessary to process your shopify order or to achieve an automatically update for the shipping information to shopify, you could": "If it is necessary to process your shopify order or to achieve an automatically update for the shipping information to shopify, you could",
  "connect your Shopify store": "connect your Shopify store",
  "and let us help you": "and let us help you",
  "If you have authorized a Shopify store, after the vendor delivers the items, the shipping information will been synchronized to your Shopify store which you had authorized.": "If you have authorized a Shopify store, after the vendor delivers the items, the shipping information will been synchronized to your Shopify store which you had authorized.",
  "If there are some Shopify stores in the order list below that have not been authorized, you can": "If there are some Shopify stores in the order list below that have not been authorized, you can",
  "authorize a new one": "authorize a new one",
  "If you need to view your recent orders, please click": "If you need to view your recent orders, please click",
  "Cancelled": "Cancelled",
  "Purchase Order": "Purchase Order",
  "Tell us more about your request": "Tell us more about your request",
  "Attach image file": "Attach image file",
  "Browse": "Browse",
  "What is your store name?": "What is your store name?",
  "Customer Support Email": "Customer Support Email",
  "Send your request": "Send your request",
  "Getting Started": "Getting Started",
  "Main Features": "Main Features",
  "Please enter Shopify store name": "Please enter Shopify store name",
  "The email must not be empty": "The email must not be empty",
  "Send Success,We will contact you soon.": "Send Success,We will contact you soon.",

  'Total Payment': 'Total Payment',
  'Total Merchandise': 'Total Merchandise',
  'SKU Details': 'SKU Details',
  "Commodity Price": "Commodity Price",
  "Subscribe to our newsletter": "Subscribe to our newsletter",
  "Promotions, new products and sales. Directly to your inbox.": "Promotions, new products and sales. Directly to your inbox.",
  "Your email": "Your email",
  "Subscribe": "Subscribe",
  "Company Information": "Company Information",
  "OUR SOCIAL MEDIA": "OUR SOCIAL MEDIA",
  "PRIVACY STATEMENT": "PRIVACY STATEMENT",
  "Terms and Conditions": "Terms and Conditions",
  "My  Profile": "My  Profile",
  "Login": "Login",
  "Please contact the supplier to improve the external number of the webmaster": "Please contact the supplier to improve the external number of the webmaster",
  "Black": "Black",
  "There are currently no products under this category": "There are currently no products under this category",
  "Logo": "Logo",
  "You can find the recent quotationsand check offers": "You can find the recent quotationsand check offers",
  "Maximum recommended size 200px * 200px, image can be adapted": "Maximum recommended size 200px * 200px, image can be adapted",
  "Add image": "Add image",
  "Change image": "Change image",
  "Shopify tags": "Tags",
  "New Tag": "New Tag",
  "Shopify type": "Product Type",
  "Loading": "Loading",
  "Compare Price": "Compare Price",
  "Cost Price": "Cost Price",
  "Sale Price": "Sale Price",
  "Product Cost": "Product Cost",
  "incorrect input":"incorrect input",
  "Tag name": "Tag name",
  "Distributor commission withdrawal": "Distributor commission withdrawal",
  "Please enter the commission withdrawal amount": "Please enter the commission withdrawal amount",
  "Please enter content": "Please enter content",
  "tradeAmount":"Trade Amount",
  "itemAmount":"Items Amount",
  "discountAmount":"Discount Amount",
  "refundAmount":"Refund Amount",
  "to":"to",
  "Selected stores": " Selected stores",
  "Please select the Shopify stores": "Please select the Shopify stores",
  "Shopify": "Shopify",
  "Woocommerce": "Woocommerce",
  "Lazada": "Lazada",
  "Shopee": "Shopee",
  'Change All': 'Change All',
  'Multiply Price': 'Multiply Price',
  'Add Price': 'Add Price',
  "Wayfair": "Wayfair",
  "Push to Store": "Push to Store",
  " Add Cost Range": " Add Cost Range",
  "Plus": "Plus",
  "Multiply": "Multiply",
  "Fixed Price": "Fixed Price",
  "You can set a specific cent value for your price or comparison": "You can set a specific cent value for your price or comparison",
  "price.": "price.",
  "Assign Cent": " Assign Cent",
  "Assign compare at Cent": " Assign compare at Cent",
  "According to store currency": " According to store currency",
  "Apply for products in Import List": "Apply for products in Import List",
  "Add New Tags": "Add New Tags",
  "Are you sure to delete it": "Are you sure to delete it??",
  "Please enter the New tag": "Please enter the New tag",
  "Do you want to delete tish task? Tips": "Do you want to delete tish task? Tips",
  "error": "error",
  "Do you want to delete the": "Möchten Sie die",
  "product(s)?": "product(s)?",
  "Delete success": "Delete success",
  "Do you want to Export the": "Möchten Sie den Export der",
  "Unit Cost": "Unit Cost",
  "Import Aliexpress'	": "Import Aliexpress / Amazon product URL here and click 'Import Product'",
  "Product SKU": "Product SKU",
  "Not purchased": "Not purchased",
  "Cost per unit": "Cost per unit",
  "Clear selection":"Clear selection",
  "Total Quantity selected": "Total Quantity selected",
  "Total Quantity": "Total Quantity",
  "Total Cartons": "Total Cartons",
  "Total CBM": "Total CBM",
  "Single": "Single",
  "Multiple": "Multiple",
  "Sale name": "Sale name",
  "Inculding supplier PL or PI": "Inculding supplier PL or PI",
  "You can find the recent quotations and check offers": "You can find the recent quotations and check offers",
  "Waiting for vendors respond": "Waiting for vendors respond",
  "Vendors responding quotations": "Vendors responding quotations",
  "Archived quotations": "Archived quotations",
  "Attachment file": "Attachment file",
  "Partially Fulfilled": "Partially Fulfilled",
  "Last 90 days": "Last 90 days",
  "Last 12 months": "Last 12 months",
  "Custom": "Custom",
  "Order number (ascending)": "Order number (ascending)",
  "Order number (descending)": "Order number (descending)",
  "Date (oldest first)": "Date (oldest first)",
  "Date (newest first)": "Date (newest first)",
  "Partially refunded": "Partially refunded",
  "orders selected": "orders selected",
  "orders selected, uncheck": "orders selected, uncheck",
  "orders selected, select all": "orders selected, select all",
  "Only orders in": "Only orders in",
  "Paid": "Paid",
  "No order selected": "No order selected",
  "Create quotation request": " Create quotation request",
  "can": "can",
  "waiting for responding": "waiting for responding",
  "Confirmed": "Confirmed",
  "ID Range": "ID Range",
  "Order Includes": "Order Includes",
  "View offers": "View offers",
  "Cancel offers": "Cancel offers",
  "Check offers": "Check offers",
  "My Store": "My Store",
  "Fulfillment": "Fulfillment",
  "Allocate": "Allocate",
  "button of the page,you can also allocate items from the same SPU to the same vendor":  "button of the page,you can also allocate items from the same SPU to the same vendor",
  "Items": "Items",
  "Details": "Details",
  "Expected price (US$)": "Expected price (US$)",
  "Vendors respond": " Vendors respond",
  "Purchase Order Reconfirm":"Purchase Order Reconfirm",
  "Vendor name": "Vendor name:",
  "AilExpress shop：": "AilExpress shop：",
  "Invite Vendor": "Invite Vendor",
  "Invite Link:":"Invite Link:",
  "Bonus Detail": "Bonus Detail",
  "Amount($)":"Amount($)",
  "Product name": "Product name",
  "Enter order number": "Enter order number",
  "Product information": "Product information",
  "Edit Product": "Edit Product",
  "Shopify vendor": "Vendor",
  "What is your Email?": "What is your Email?",
  "Cancel purchase order": "Cancel purchase order",
  "Use this button to update if missing orders.The process may take a while to finish.": "Use this button to update if missing orders.The process may take a while to finish.",
  "Offered Orders": "Offered Orders",
  "Offered Products": "Offered Products",
  "Offer price": "Offer price",
  "View offer detail": "View offer detail",
  "Hold down the slider and drag to the right": "Hold down the slider and drag to the right",
  "In order to keep you informed of the update of the order, we suggest you verify the email": "In order to keep you informed of the update of the order, we suggest you verify the email",
  "orders can be process, what do you want to do now?": "orders can be process, what do you want to do now?",
  "Need new quotation for my orders": "Need new quotation for my orders",
  "Over 30000+ vendors waiting for offer you price": "Over 30000+ vendors waiting for offer you price",
  "Allocate my exist vendors":"Allocate my exist vendors",
  "Just check my orders": "Just check my orders",
  "If you already have cooperative vendors, you can allocate orders to them": "If you already have cooperative vendors, you can allocate orders to them",
  "How to process your orders?": "How to process your orders?",
  "Please select at least one order and quote for your order": "Please select at least one order and quote for your order",
  "Confirm this Offer": "Confirm this Offer",
  "All Orders": "All Orders",
  "All Products": "All Products",
  "Yes, I want to CANCEL this offer": "Yes, I want to CANCEL this offer",
  "Cancel the success": "Cancel the success",
  "Volume(cm)": "Volume(cm)",
  "Total volume(cm)": "Total volume(cm)",
  "You have successfully completed your order.": "You have successfully completed your order.",
  "Pay again": "Pay again",
  "Receiving": "Receiving",
  "days": "days",
  "Shipping days ": "Shipping days ",
  "Discount": "Discount",
  "Exchange": "Exchange",
  "The supplier has opened a credit limit for you. When your account balance is insufficient, you can deduct the credit limit": "The supplier has opened a credit limit for you. When your account balance is insufficient, you can deduct the credit limit",
  "Quantity of order ": "Quantity of order ",
  "Total amount of goods": "Total amount of goods",
  "Tax Amount": "Tax Amount",
  "Discounted price of goods": "Discounted price of goods",
  "Total freight amount": "Total freight amount",
  "Shop discount": "Shop discount",
  "This document is free of freight": "This document is free of freight",
  "credit&debit card": "credit&debit card",
  "qr payment": "qr payment",
  "Your No.": "Your No.",
  "Create Quote": "Create Quotation",
  "Bulk payment": "Bulk Payment",
  "Shop price": "Shop price",
  "warehouse": "warehouse",
  "address": "address",
  "Product": "Product",
  "Manually synced": "Manually synced",
  "Payment time": "Payment time",
  "Inventory lock remaining time": "Inventory lock remaining time",
  "Order quantity": "Order quantity",
  "Cancel payment": "Cancel payment",
  "Request Fullfill": "Request Fullfill",
  "Paid Time": "Paid Time",
  "Deliver Time": "Deliver Time",
  "Select Payment Method": "Select Payment Method",
  "All transactions are secure and encrypted": "All transactions are secure and encrypted",
  "Quotation to be submitted": "Quotation to be submitted",
  "Quoted": "Quoting",
  "Unfulfilled": "Unfulfilled",
  "danger": "danger",
  "Delivery Address": "Delivery Address",
  "warning": "warning",
  "Binding succeeded!": "Binding succeeded!",
  "There is no warehouse, please go to add!": "There is no warehouse, please go to add!",
  "file cannot over 2MB": "file cannot over 2MB",
  "Please select an order firs": "Please select an order firs",
  "Successfully": "Successfully",
  "Are you sure to initiate a quotation for the selected order?": "Are you sure to initiate a quotation for the selected order?",
  "Are you sure to abandon the quotation for the selected order? After giving up, it cannot be restored, please operate with caution": "Are you sure to abandon the quotation for the selected order? After giving up, it cannot be restored, please operate with caution",
  "Payment has not arrived": "Payment has not arrived",
  "Awaiting Fulfillment": "Awaiting Fulfillment",
  "SortBy":"SortBy",
  "Date Ranges": "Date Ranges",
  "Export to": "Export to",
  "Selected": "Selected",
  "Some orders had been fulfilled or refunded": "Some orders had been fulfilled or refunded",
  "Export orders": "Export orders",
  "Abnormal reason":"Abnormal reason",
  "Date type": "Date type",
  "Download tracking information": "Download tracking information",
  "Depending on how many Orders you’re exporting, this could take some time.": "Depending on how many Orders you’re exporting, this could take some time.",
  "<strong>Your Orders are exporting</strong><br/>Your export will be delivered by email to: . <br/>Depending on how many Orders you’re exporting, this could take some time.": "<strong>Your Orders are exporting</strong><br/>Your export will be delivered by email to: . <br/>Depending on how many Orders you’re exporting, this could take some time.",
  "Notice": "Notice",
  "purchase order(s) need your reconfirm,": " purchase order(s) need your reconfirm,",
  "click here": "click here",
  "to view details.": "to view details.",
  "Vendor shipped": "Vendor shipped",
  "unfulfilled / partially fulfilled)": "unfulfilled / partially fulfilled)",
  "But": "But",
  "You may download these tracking information and fulfilled these orders in your Shopify store manualy.": "You may download these tracking information and fulfilled these orders in your Shopify store manualy.",
  "Download ALL tracking information": "Download ALL tracking information",
  "Reconfirm": "Reconfirm",
  "Cancel this order": "Cancel this order",
  "NOT Joined": "NOT Joined",
  "Not set up": "Not set up",
  "View Details": "View Details",
  "Send to vendor": "Send to vendor",
  "Title": "Title",
  "Order Title": "Order Title",
  "Desc": "Desc",
  "Feedback": "Feedback",
  "Includes": "Includes",
  "Shopify orders": "Shopify orders",
  "products": "products",
  "invalid":"invalid",
  "Income": "Income",
  "Income will only visible to you": "Income will only visible to you",
  "Allow vendor to process these orders": "Allow vendor to process these orders",
  "Do you want to cancel this order?": "Do you want to cancel this order?",
  "Don't worry, after cancelling this purchase order, you can still find your": "Don't worry, after cancelling this purchase order, you can still find your",
  "Shopify orders in the 'Waiting for sourcing' menu and re-place the purchase order": "Shopify orders in the 'Waiting for sourcing' menu and re-place the purchase order",
  "Change purchase order to another vendor": "Change purchase order to another vendor",
  "Current vendor:": "Current vendor:",
  "Change to new vendor": "Change to new vendor",
  "All my vendors": "All my vendors",
  "Also allocate the products in this purchase order to the new supplier": "Also allocate the products in this purchase order to the new supplier",
  "Order created": "Order created",
  "Order paid": "Order paid",
  "Login to your": "Login to your",
  "Order confirmed": "Order confirmed",
  "Your request is been submitted, please wait one moment.": "Your request is been submitted, please wait one moment.",
  "The update process has started, it will take a while to finish.": "The update process has started, it will take a while to finish.",
  "You have": "You have",
  "purchase orders": "purchase orders",
  "NEED to finish payment": "NEED to finish payment",
  "Waiting for allocated": "Waiting for allocated",
  "Waiting for sourcing ": "Waiting for sourcing ",
  "Orders processing": "Orders processing",
  "Abnormal order ": "Abnormal order ",
  "Quote for Orders": "Quote for Orders",
  "Quote for Product": "Quote for Product",
  "Recent Quotations": "Recent Quotations",
  "orders matching your search": "orders matching your search",
  "SPU": "SPU",
  "Store": "Store",
  "Email": "Email",
  "Get captcha": "Get captcha",
  "Please fill in the correct Email address": "Please fill in the correct Email address",
  "User Email modified successfully": "User Email modified successfully",
  "Your Orders are exporting</strong><br/>Your export will be delivered by email to": "Your Orders are exporting</strong><br/>Your export will be delivered by email to",
  "<br/>Depending on how many Orders you’re exporting, this could take some time": "<br/>Depending on how many Orders you’re exporting, this could take some time",
  "Show cancelled orders": "Show cancelled orders",
  "Show all valid orders": " Show all valid orders",
  "unfulfilled / partially fulfilled": " unfulfilled / partially fulfilled",
  "Download NOT FULFILLED tracking information": "Download NOT FULFILLED tracking information",
  "sync failed": " sync failed",
  "Change another vendor": "Change another vendor",
  "Invite vendor to process": "Invite vendor to process",
  "More Action": "More Action",
  "Selected saved! Now you can Check the purchase orders": "Selected saved! Now you can Check the purchase orders",
  "After your confirmation for the payment, we will notify the vendor by email. You can also proactively notify the vendor to speed the delivery up": "After your confirmation for the payment, we will notify the vendor by email. You can also proactively notify the vendor to speed the delivery up",
  "Have you finished the payment?": "Have you finished the payment?",
  "Confirm the payment": "Confirm the payment",
  "The reason must be entered": "The reason must be entered",
  "In this tab, we will only filter your": "In this tab, we will only filter your",
  "Orders which you can allocate to your vendor to process.": " Orders which you can allocate to your vendor to process.",
  "Shop name": "Shop name",
  "Partially fulfilled": "Partially fulfilled",
  "Fulfillment Status": "Fulfillment Status",
  "Allocate all to vendor": "Allocate all to vendor",
  "purchased items are delivered": "purchased items are delivered",
  "Select a vendor": "Select a vendor",
  "Product has been allocated": "Product has been allocated",
  "Vendor name / contact / shop name etc.": "Vendor name / contact / shop name etc.",
  "Here are some other products seems can been allocated to the vendor too, do you want to do it now?": "Here are some other products seems can been allocated to the vendor too, do you want to do it now?",
  "Selected products": "Selected products",
  "Allocate NOW": "Allocate NOW",
  "No thanks": "No thanks",
  "Please select at least one order": "Please select at least one order",
  "Create quotation request?": "Create quotation request?",
  "Order ID From:": "Order ID From:",
  "Order ID To:":"Order ID To:",
  "You're going to place": " You're going to place",
  "orders to": "orders to",
  "responded": "responded",
  "You can choose the payment method you can accept, we will submit your": "You can choose the payment method you can accept, we will submit your",
  "orders and options to your vendors": "orders and options to your vendors",
  "Warm tips": "Warm tips",
  "orders NOW": "orders NOW",
  "Place": "Place",
  "You have set the following products to be allocated to the vendors": "You have set the following products to be allocated to the vendors",
  "only once. Therefore, the following items will need to be": "only once. Therefore, the following items will need to be",
  "re-allocated after the orders are generated again.": "re-allocated after the orders are generated again.",
  "By AliExpress VIP link": "By AliExpress VIP link",
  "Product title": "Product title",
  "Expected price": "Expected price",
  "Current price": "Current price",
  "Reply price": "Reply price",
  "Reply link": "Reply link",
  "published": "published",
  "My support": "My support",
  "You have successfully hosted the": "You have successfully hosted the",
  "Failure reason": "Failure reason",
  "Store products": "Store products",
  "Query": "Query",
  "Please enter": "Please enter",
  "State": "State",
  "Penging": "Penging",
  "Description": "Description",
  "Add Vendor": "Add Vendor",
  "Edit Vendor": "Edit Vendor",
  "Destination Country": "Destination Country:",
  "My sourcing products": "My sourcing products",
  "Vendor information": "Vendor information",
  "Vendor Contact": "Vendor Contact",
  "Bonus Balance($)": "Bonus Balance($)",
  "Sales statistics": "Sales statistics",
  "Please enter description": "Please enter description",
  "Please enter IOSS ID": "Please enter IOSS ID",
  "Please select destination country": "Please select destination country",
  "Please select at least 1 destination country.": "Please select at least 1 destination country.",
  "Please enter an IOSS ID with 12 alphanumeric characters.": "Please enter an IOSS ID with 12 alphanumeric characters.",
  "After saving, your IOSS will be updated to the corresponding order. Are you sure to save?": "After saving, your IOSS will be updated to the corresponding order. Are you sure to save?",

  "Settings": "Settings",
  "According to the new European VAT e-commerce rules, declaration without lOSS will result in a delay in customs clearance and the recipient will be required to pay VAT, as the parcel will be detained when contact of the recipient is incorrect.": "According to the new European VAT e-commerce rules, declaration without lOSS will result in a delay in customs clearance and the recipient will be required to pay VAT, as the parcel will be detained when contact of the recipient is incorrect.",
  "IOSS Option": "IOSS Option",
  "No IOSS": "No IOSS",
  "The amount of the orders (shipping cost included) will be declared and recipients will be required by the customs to pay VAT when parcels arrive in the destination countries of EU": "The amount of the orders (shipping cost included) will be declared and recipients will be required by the customs to pay VAT when parcels arrive in the destination countries of EU",
  "Please enter correct and valid IOSS IDs, which should be linked to corresponding destination countries. IOSS ID will not be applied if the destination country is not linked to a correct IOSS ID": "Please enter correct and valid IOSS IDs, which should be linked to corresponding destination countries. IOSS ID will not be applied if the destination country is not linked to a correct IOSS ID",
  "My IOSS Settings": "My IOSS Settings",
  "Declare with my own IOSS": "Declare with my own IOSS",
  "Linked Countries": "Linked Countries",
  "Add IOS": "Add IOSSou sure to delete the IO",
  "Unlinked Countries:": "Unlinked Countries:",
  "Are you sure to delete the IOSS?": "Are you sure to delete the IOSS?",
  "Excluding VAT amount": "Excluding VAT amount",
  "VAT am": "Vat Amount",
  "Amount including VAT": "Amount including VAT",
  "AliExpress store information": "AliExpress store information",
  "Detailed seller ratings": "Detailed seller ratings",
  "Recent Products": "Recent Products",
  "Store No.": "Store No.",
  "This store has been open since": "This store has been open since",
  "Positive feedback": "Positive feedback",
  "Business License": "Business License",
  "Item as Described": "Item as Described",
  "Above": "Above",
  "Below": "Below",
  "Average": "Price per unit",
  "Shipping Speed": "Shipping Speed",
  "Detailed Seller Ratings information is unavailable when there're less than 10 rating": "Detailed Seller Ratings information is unavailable when there're less than 10 rating",
  "My Vendors": " My Vendors",
  "By Vendor Name": "By Vendor Name",
  "By AliExpress Url": "By AliExpress Url",
  "Please enter your vendor's name": "Please enter your vendor's name",
  "Vendor's Name": "Vendor's Name",
  "Vendor's AliExpress shop or product URL": " Vendor's AliExpress shop or product URL",
  "How to get the vendor's AliExpress shop / product URL?": "How to get the vendor's AliExpress shop / product URL?",
  "Transaction Flow Line": "Transaction Flow Line",
  "Recharge Time": "Recharge Time",
  "customer successfully edited": "customer successfully edited",
  "customer successfully added": "customer successfully added",
  "Address Management": "Address Management",
  "Default Shipping Address": "Default Shipping Address",
  "First name": "First name",
  "Last name": "Last name",
  "Phone": "Phone",
  "Address": "Address",
  "City": "City",
  "Postcode": "Postcode",
  "Province": "Province",
  "Country": "Country",
  "No address": "No address",
  "Do you want to delete?": "Do you want to delete?",
  "delete successfully": "delete successfully",
  "My Allocated Products": "My Allocated Products",
  "save successfully": "save successfully",
  "My Allocated Product": "My Allocated Product",
  "Batch Re-allocate": "Batch Re-allocate",
  "Batch Un-allocate": "Batch Un-allocate",
  "All my stores": "All my stores",
  "UN-allocate Success": "UN-allocate Success",
  "Receipt": "Receipt",
  "LOGIN": "LOGIN",
  "Privacy policy": "Privacy policy",
  "Terms of use": "Terms of use",
  "Refund Policy": "Refund Policy",
  "FAQs": "FAQs",
  "This file format is not supported": "This file format is not supported",
  "The file size can not over 2MB": "The file size can not over 2MB",
  "Please input your message": "Please input your message",
  "BCNDropshipping - Easy Dropshipping": "BCNDropshipping - Easy Dropshipping",
  "The question must not be empty": "The question must not be empty",
  "Shopify store name": "Shopify store name",
  "Current Unit Cost": "Current Unit Cost",
  "Welcome to": "Welcome to",
  "Please sign in or register an account to start the chat.": "Please sign in or register an account to start the chat.",
  "All Items": "All Items",
  "back": "back",
  "Check All": "Check All",
  "Digital Themrmometer Hygrometer Living Ro Digital Themrmometer Hygrometer Living Ro": "Digital Themrmometer Hygrometer Living Ro Digital Themrmometer Hygrometer Living Ro",
  "Bulk Purchase": "Bulk Purchase",
  "Do you want to delete selected items?": "Do you want to delete selected items?",
  "Hi, welcome to": "Hi, welcome to",
  "Welcome to ()! Please sign in or register an account to": "Welcome to ()! Please sign in or register an account to",
  "start the chat.": " start the chat.",
  "Register": "Register",
  "Recall": "Recall",
  "Trade name": "Trade name",
  "Purchase price:": "Purchase price:",
  "Start date": "Start date",
  "End date": "End date",
  "Expected Price": "Expected Price",
  "Product link": "Product link",
  "Product note": "Note",
  "Screenshot": "Screenshot",
  "Dispatched Items": "Dispatched Items",
  "Valid Invoices": "Valid Invoices",
  "Valid Amount Due": "Valid Amount Due",
  "Order items that you can dispatch to vendors": "Order items that you can dispatch to vendors",
  "No Picture": "No Picture",
  "Dispatch order's items to vendors": "Dispatch order's items to vendors",
  "You can modify your order dispatch rules at any time in the menu 'MyOrders >> Dispatch settings'": " You can modify your order dispatch rules at any time in the menu 'MyOrders >> Dispatch settings'",
  "Dispatch to": "Dispatch to",
  "vendor(s)": "vendor(s)",
  "Complete  personal information": "Complete  personal information",
  "Start pulling   orders": "Start pulling   orders",
  "Please select the vendor": "Please select the vendor",
  "Please select the circle period": "Please select the circle period",
  "Are you sure you want to cancel it?": "Are you sure you want to cancel it?",
  "Disputed order": "Disputed order",
  "Awaiting Response": "Awaiting Response",
  "Search": "Search",
  "Tracking Number": "Tracking Number",
  "Dispute Type": "Dispute Type",
  "Expected Solution": "Expected Solution",
  "Last week": "Last week",
  "Last month": "Last month",
  'OK': 'OK',
  "Type": "Type",
  "Select country": "Select country",
  "Last three months": "Last three months",
  "The page you are looking for can't be found.": "The page you are looking for can't be found.",
  "BACK TO HOMEPAGE": "BACK TO HOMEPAGE",
  "Transform Your eCommerce business Into a Powerhouse": "Transform Your eCommerce business Into a Powerhouse",
  "Importify helps people like you to automate their dropshipping business.": "Importify helps people like you to automate their dropshipping business.",
  "Product Research": "Product Research",
  "Are you tired of searching the millions o products on AliExpress for potential winners?": "Are you tired of searching the millions o products on AliExpress for potential winners?",
  "One-click import products": "One-click import products",
  "Profit": "Profit",
  "Import products from 30+ top dropshipping vendors, Aliexpress, Alibaba, Amazon, Etsy, Dhgate, Lazada, Shopee, Banggood, Taobao, 1688, Gearbest, Walmart, and many more.": "Import products from 30+ top dropshipping vendors, Aliexpress, Alibaba, Amazon, Etsy, Dhgate, Lazada, Shopee, Banggood, Taobao, 1688, Gearbest, Walmart, and many more.",
  "Pricing Rules": "Pricing Rules",
  "Tired of calculating your target profit margin? Create pricing rules before importing, quickly adjust prices for sales.": "Tired of calculating your target profit margin? Create pricing rules before importing, quickly adjust prices for sales.",
  "Product Customization": "Product Customization",
  "Use our chrome extension to modify the title, description, images, variants, pricing of the imported products.": "Use our chrome extension to modify the title, description, images, variants, pricing of the imported products.",
  "Automate your orders": "Automate your orders",
  "The Importify Chrome Extension allows you to fulfill your orders quickly by placing the customer address automatically on the checkout page.": "The Importify Chrome Extension allows you to fulfill your orders quickly by placing the customer address automatically on the checkout page.",
  "Easy vendor Change": "Easy vendor Change",
  "Replace your product vendor with a new vendor and connect them to your store with a click.": "Replace your product vendor with a new vendor and connect them to your store with a click.",
  "Auto Dispatch Collections": "Auto Dispatch Collections",
  " Auto-dispatch products to your Store collections supported on Shopify, WooCommerce, and Jumpseller.": " Auto-dispatch products to your Store collections supported on Shopify, WooCommerce, and Jumpseller.",
  "Split Variants": "Split Variants",
  'Variants': 'Variants',
  "Importify gives you the ability to Split variants into Separate products.": "Importify gives you the ability to Split variants into Separate products.",
  "Connect Existing Products": "Connect Existing Products",
  "If you have products that are already on a Shopify, Woocommerce or Jumpseller store, you can connect and manage them in Importify.": "If you have products that are already on a Shopify, Woocommerce or Jumpseller store, you can connect and manage them in Importify.",
  "Add to Import List": "Add to Import List",
  "View More": "View More",
  "MORE": "MORE",
  "Categories": "Categories",
  "Tag": "Tag",
  "Returnable with in":"Returnable with in",
  "No Account? ": "No Account? ",
  "Find Products": "Find Products",
  "My Import List": "My Import List",
  "Please select a shipping address": "Please select a shipping address",
  "Please select a shipping method":"Please select a shipping method",
  "How to find products? Find products in": "How to find products? Find products in",
  "Products Market! Dropshipping from Worldwide to Worldwide! :": "Products Market! Dropshipping from Worldwide to Worldwide! :",
  "Email must be filled in": "Email must be filled in",
  "CAPTCHA must be filled in": "CAPTCHA must be filled in",
  "New password must be filled in": "New password must be filled in",
  "The new password and confirm password must be the same": "The new password and confirm password must be the same",
  "The password must contain letters, and numbers, Minimum 8 characters": "The password must contain letters, and numbers, Minimum 8 characters",
  "Password reset successful": "Password reset successful",
  "Password must be filled in": "Password must be filled in",
  "IN ALL CATEGORIES": "IN ALL CATEGORIES",
  "Request Quotation": "Request Quotation",
  "More categories": "More categories",
  "Place Order": "Place Order",
  "Choose orders": "Choose orders",
  "Manage-Addresses": "Manage-Addresses",
  "Default Address": "Default Address",
  "There is no Shipping method to reach the current address": "There is no Shipping method to reach the current address",
  "Please select address": "Please select address",
  "Product Price": "Product Price",
  "Choose the products from your Shopify orders to allocated to your vendor": "Choose the products from your Shopify orders to allocated to your vendor",
  "Click the Allocate to vendo button on the bottom of the page.": "Click the Allocate to vendo button on the bottom of the page.",
  "Tips: You can filter your orders here.": "Tips: You can filter your orders here.",
  "Choose or create a new vendor.": "Choose or create a new vendor.",
  "Click the Allocate button of the page,you can also allocate items from the same SPU to the same vendor": "Click the Allocate button of the page,you can also allocate items from the same SPU to the same vendor",
  "Un-allocate selected products": "Un-allocate selected products",
  "Total vendors": "Total vendors",
  "Total orders": "Total orders",
  "Click the": "Click the",
  "Allocate to vendor": "Allocate to vendor",
  "button on the bottom of the page.": "button on the bottom of the page.",
  "Total Product": "Total Product",
  "Previous": "Previous",
  "Next": "Next",
  "and Automate": "and Automate",
  "your entire dropshipping process": "your entire dropshipping process",
  "Place 1 purchase orders": "Place 1 purchase orders",
  "With just one click, you can easily allocate your stores orders to your vendors and the entire shipping process will be automatically completed.": "With just one click, you can easily allocate your stores orders to your vendors and the entire shipping process will be automatically completed.",
  "Create a purchase orders to your vendor.": "Create a purchase orders to your vendor.",
  "Choose the Shopify orders you want to sourcing,and click the Make a purchase order button of the page.": "Choose the Shopify orders you want to sourcing,and click the Make a purchase order button of the page.",
  "After confirming the operation,The purchase orders will be created successfully.": "After confirming the operation,The purchase orders will be created successfully.",
  "Share purchase orders URL to your vendor and wait your vendor finish the invoice for you.": "Share purchase orders URL to your vendor and wait your vendor finish the invoice for you.",
  "Click the <b>Invite vendor to process</b> button on the bottom of the page.": "Click the <b>Invite vendor to process</b> button on the bottom of the page.",
  "You can send the purchase orders by Skype, WeChat or share by URL link.": "You can send the purchase orders by Skype, WeChat or share by URL link.",
  "I have finished the payment": "I have finished the payment",
  "<b>Invite vendor to process</b>": "<b>Invite vendor to process</b>",
  "Items total": "Items total",
  "You can create a new vendor or select an exist one.": "You can create a new vendor or select an exist one.",
  "Amount Due": "Amount Due",
  "Click the button": "Click the button",
  "on the PO page when you finished your payment.": "on the PO page when you finished your payment.",
  "Through AliExpress proxy payment link": "Through AliExpress proxy payment link",
  "Invite vendor to proess purchase order": "Invite vendor to proess purchase order",
  "After you receive the vendor's invoice and finished the payment.": "After you receive the vendor's invoice and finished the payment.",
  "Click the button <b>I have finished the payment</b> on the PO page when you finished your payment.": "Click the button <b>I have finished the payment</b> on the PO page when you finished your payment.",
  "After vendor shipped, Shopify order will be fulfilled automatically.": "After vendor shipped, Shopify order will be fulfilled automatically.",
  "After your vendor shipped your order, the shipping information will be sync to your Shopify store automatically.": "After your vendor shipped your order, the shipping information will be sync to your Shopify store automatically.",
  "Billing History": "Billing History",
  "Billing": "Billing",
  "Search by bill number or order number": "Search by bill number or order number",
  "Order Code": "Order Code",
  "Payment Method": "Payment Method",
  "Request for Quote": "Request for Quote",
  "Wait for import": "Wait for import",
  "Allocate Orders for vendors": "Allocate Orders for vendors",
  "and Automate <br />your entire dropshipping process": "and Automate <br />your entire dropshipping process",
  "With just one click, you can easily allocate your stores orders to": "With just one click, you can easily allocate your stores orders to",
  "your vendors and the entire shipping process will be automatically": "your vendors and the entire shipping process will be automatically",
  "completed.": "completed.",
  "How does it work?": "How does it work?",
  "Connect to your store": " Connect to your store",
  "Allocate orders to your vendors": " Allocate orders to your vendors",
  "The vendor arranges the delivery": "The vendor arranges the delivery",
  "Automatic fulfillment of your orders by": "Automatic fulfillment of your orders by",
  "See what our": "See what our",
  "customers talk about us.": " customers talk about us.",
  "More than 10,000+ customers around the world rely on us!": "More than 10,000+ customers around the world rely on us!",
  "about": "about",
  "Inquiry":"Inquiry",
  "Trial calculation of shipping costs": 'Trial calculation of shipping costs',
  "Return able with in": "Return able with in",
  "You can import and manage your AliExpress / Amazon products here": "You can import and manage your AliExpress / Amazon products here",
  "before publishing them to your Shopify store. You can publish a": "before publishing them to your Shopify store. You can publish a",
  "product to different stores and add multiple tags to each products.": "product to different stores and add multiple tags to each products.",
  "The Shopify orders still unfulfilled / partially fulfilled even if the vendor had upload tracking information.": "The Shopify orders still unfulfilled / partially fulfilled even if the vendor had upload tracking information.",
  "You may download these tracking information and fulfilled these order in your Shopify store manually.":"You may download these tracking information and fulfilled these order in your Shopify store manually.",
  "Click": "Click",
  "New Type": "New Type",
  "need your reconfirm,": "need your reconfirm,",
  "here": "here",
  "待审批":"Pending",
  "已审批":"Approved",
  "to leam more": " to leam more",
  "Import Produc": "Import Produc",
  "Current Import Task": "Current Import Task",
  "Import Task": "Import Task",
  "Filter by stores": "Filter by stores",
  "Upload Progress:": "Upload Progress:",
  "Filter by tags": "Filter by tags",
  "Select an image": "Select an image",
  "Add Cost Range": "Add Cost Range",
  "Rest of the price ranges": "Rest of the price ranges",
  "Also publish to Online Store": "Also publish to Online Store",
  "Loading time to long, check detailed progress": "Loading time to long, check detailed progress",
  "Delete Completed": "Delete Completed",
  "Please select the stores": "Please select the stores",
  "Please enter the tag": "Please enter the tag",
  "The update has started, it will take a while to finish.": "The update has started, it will take a while to finish.",
  "Do you want to delete the ${} product(s)?": "Do you want to delete the ${} product(s)?",
  "Please enter your store name to connect the dashboard page:": "Please enter your store name to connect the dashboard page:",
  "Coming soon": "Coming soon",
  "Track Number": "Track Number",
  "Shopify order number":"Shopify order number",
  "Shopify store Name": "Shopify store Name",
  "Keywords": "Keywords",
  "results": "results",
  "Assign orders to vender": "Assign orders to vender",
  "Step One: Select not shipped orders": "Step One: Select not shipped orders",
  "Step Two: Confirm and send these orders to the vendor": "Step Two: Confirm and send these orders to the vendor",
  "Choose one vendor": "Choose one vendor",
  "Please choose one vendor first": "Please choose one vendor first",
  "Abort to assign": "Abort to assign",
  "Go to Next": "Go to Next",
  "Go": "Go",
  "Confirm and send these orders to this vendor": "Confirm and send these orders to this vendor",
  "You can check the invoice by scan this QR Code or visit this URL by your web browser": "You can check the invoice by scan this QR Code or visit this URL by your web browser",
  "Time Created": " Time Created",
  "Receiver": "Receiver",
  "Company": "Company",
  "Save and change the vendor": "Save and change the vendor",
  "Selected saved": "Selected saved",
  "Now you can": "Now you can",
  "Check the list again": "Check the list again",
  "Send purchase orders to the vendor": "Send purchase orders to the vendor",
  "All Unfulfilled Shopify Orders": "All Unfulfilled Shopify Orders",
  "Shopify order total": "Shopify order total",
  "Order Date": "Order Date",
  "Periods of orders:": "Periods of orders:",
  "Quick select of Shopify order items": "Quick select of Shopify order items",
  "shopify orders have been selected and can now be dispatched to your vendor": "shopify orders have been selected and can now be dispatched to your vendor",
  "Please choose an vendor": "Please choose an vendor",
  "Please choose an item": "Please choose an item",
  "A new order successfully created": "A new order successfully created",
  "All shopify unshipped orders": "All shopify unshipped orders",
  "All undelivered shopify orders": "All undelivered shopify orders",
  "shopify orders have been selected and can now be assigned to your suppliers": "shopify orders have been selected and can now be assigned to your suppliers",
  "Recharge": "Recharge",
  "trade code": "trade code",
  "Payment Amount": "Payment Amount",
  "Payment Status": "Payment Status",
  "Payment Date": "Payment Date",
  "If it is necessary to process your shopify order or to achieve an automatically update for the shipping information toshopify, you could": "If it is necessary to process your shopify order or to achieve an automatically update for the shipping information toshopify, you could",
  "and let us help you.": "and let us help you.",
  "(If there are some Shopify stores in the order list below that have not been authorized, you can": "(If there are some Shopify stores in the order list below that have not been authorized, you can",
  "My to view details.": "My to view details.",
  "The vendor has shipped the product(s), but the shipping information has not been sync to your Shopify store.": " The vendor has shipped the product(s), but the shipping information has not been sync to your Shopify store.",
  "Will not ship": "Will not ship",
  "Not shipped": "Not shipped",
  "Logistics fee": "Logistics fee",
  "The webmaster has confirmed the  payment": "The webmaster has confirmed the  payment",
  "Via paypal": "Via paypal",
  "Through a bank transfer": "Through a bank transfer",
  "Invite vendor to process purchase order": "Invite vendor to process purchase order",
  "webmaster has confirmed the payment": "webmaster has confirmed the payment",
  "The vendor start delivery the orders": "The vendor start delivery the orders",
  "Invite vendor": "Invite vendor",
  "You can download order's shipping information here when I arranges the delivery.": "You can download order's shipping information here when I arranges the delivery.",
  "Timeline": "Timeline",
  "No more comment": "No more comment",
  "You have connected a Shopify store before, for your data security, please": "You have connected a Shopify store before, for your data security, please",
  "log in the Shopify account": "log in the Shopify account",
  "you connected and view this invoice's details.": "you connected and view this invoice's details.",
  "I knew it": "I knew it",
  "you can dispatch the Shopify orders to your vendors after the authorization and the shipping information will be automatically synchronized to your Shopify Store.": "you can dispatch the Shopify orders to your vendors after the authorization and the shipping information will be automatically synchronized to your Shopify Store.",
  "Enter your existing Shopify URL bellow and click “connect”, you will be redirect to Shopify to connect your account to (the authorization will be also completed).": "Enter your existing Shopify URL bellow and click “connect”, you will be redirect to Shopify to connect your account to (the authorization will be also completed).",
  "Connect your Shopify store": "Connect your Shopify store",
  "Connect a store and fulfill your Shopify orders, sync logistics information to your Shopify store automatically.": "Connect a store and fulfill your Shopify orders, sync logistics information to your Shopify store automatically.",
  "Enter your existing Shopify store URL bellow and you'll be  redirect to Shopify to connect your account to": "Enter your existing Shopify store URL bellow and you'll be  redirect to Shopify to connect your account to",
  "Set the vendor’s SKU": "Set the vendor’s SKU",
  "Set the supply price": "Set the supply price",
  "Set up payment methods": "Set up payment methods",
  "Payment Methods": "Payment Methods",
  "Send the invoice to the customer": "Send the invoice to the customer",
  "The fields to be exported": "The fields to be exported",
  "the sequence is adjustable by dragging forward and backward": "the sequence is adjustable by dragging forward and backward",
  "optional fields": "optional fields",
  "unexported fields": "unexported fields",
  "custom field name": "custom field name",
  "is displayed as": "is displayed as",
  "Export order's information to CSV": "Export order's information to CSV",
  "BILL To": "BILL To",
  "Invoice Number": "Invoice Number",
  "Invoice Date": "Invoice Date",
  "Amount Due (US$)": "Amount Due (US$)",
  "Mark as shipped": "Mark as shipped",
  "The webmaster has confirmed the payment": "The webmaster has confirmed the payment",
  "The vendor has confirmed the payment": "The vendor has confirmed the payment",
  "According to the vendor's setting you can go to": "According to the vendor's setting you can go to",
  "Aliexpress to buy the item in the vendor’s store": "Aliexpress to buy the item in the vendor’s store",
  "to finish the payment": "to finish the payment",
  "Go to AliExpress NOW": "Go to AliExpress NOW",
  "The vender has confirmed the payment.": "The vender has confirmed the payment.",
  "Remove from order": "Remove from order",
  "You are deleting this product from purchase order. You can still find it": "You are deleting this product from purchase order. You can still find it",
  "in your 'Waiting for sourcing' menu.": "   in your 'Waiting for sourcing' menu.",
  "Total Amount:": "Total Amount:",
  "Your order has been successfully paid and the order amount is": "Your order has been successfully paid and the order amount is",
  "Close Pay": "Close Pay",
  "Remove success": "Remove success",
  "Track number must be entered": "Track number must be entered",
  "Track company must be entered": "Track company must be entered",
  "Track company  must be entered": "Track company  must be entered",
  "Track Url must be entered": "Track Url must be entered",
  "Please enter Shopify store URL": "Please enter Shopify store URL",
  "Under authorization, please wait…": "Under authorization, please wait…",
  "Have you finished the payment": "Have you finished the payment",
  "At least one field must be selected": "At least one field must be selected",
  "The name of the customized header cannot be empty": "The name of the customized header cannot be empty",
  "Export the order information": "Export the order information",
  "Simple, Transparent Pricing": "Simple, Transparent Pricing",
  "mportify offers three types of plans; Basic plan, Premium plan, and Gold plan.": "mportify offers three types of plans; Basic plan, Premium plan, and Gold plan.",
  "Each account starts with a day trial, and your billing cycle begins after the free trial period has ended.": " Each account starts with a day trial, and your billing cycle begins after the free trial period has ended.",
  "Importify Plans<": "Importify Plans<",
  "Basics": "Basics",
  "Premium": "Premium",
  "Gold": "Gold",
  "Offers": "Offers",
  "Amazon & Aliexpress importer": " Amazon & Aliexpress importer",
  "Semi-automatic order fulfillment (Supported on Aliexpress, Amazon, Dhgate & Wonify)": "  Semi-automatic order fulfillment (Supported on Aliexpress, Amazon, Dhgate & Wonify)",
  "Product Customisation": "Product Customisation",
  "Update Product": "Update Product",
  "Shipping Time": "Shipping Time",
  "After Sales Service": "After Sales Service",
  "product description": "product description",
  "Store price": "Store price",
  "Delivery:   Varies for items shipped from an international location": "Delivery:   Varies for items shipped from an international location",
  "This product has been removed from the shelves": "This product has been removed from the shelves",
  "Return": "Return",
  "Enter Store name": "Enter Store name",
  "Enter vendor name": "Enter vendor name",
  "Allow Customer Services from ": "Allow Customer Services from ",
  "Purchase List": "Purchase List",
  "Complete your Skype or WhatsApp details to get rewards": "Complete your Skype or WhatsApp details to get rewards",
  "You have completed the Skype or WhatsApp, you can receive a free gift package.": "You have completed the Skype or WhatsApp, you can receive a free gift package.",
  "The captcha was sent successfully": "The captcha was sent successfully",
  "Order Details": "Order Details",
  "Sub Order NO": "Sub Order NO",
  "Product Information": "Product Information",
  "Sub Total": "Sub Total",
  "Grand Total": "Grand Total",
  "Tracking Number:": " Tracking Number:",
  "Total Amount": "Total Amount",
  "Products Cost": "Products Cost",
  "Enter SKU": "Enter SKU",
  "Package": "Package",
  "I agree the": "I agree the",
  "Pay NOW": "Pay NOW",
  "All vendors": "All vendors",
  "Dispatch Status": "Dispatch Status",
  "You could select multiple vendors": "You could select multiple vendors",
  "Shipping Cost Included": "Shipping Cost Included",
  "Do you want to cancel the order?": "Do you want to cancel the order?",
  "Order was successfully cancelled": "Order was successfully cancelled",
  "Choose your recharge package": "Choose your recharge package",
  "Choose your payment method": "Choose your payment method",
  "Payment Record": "Payment Record",
  "Platform Reply": "Platform Reply",
  "Picture": "Picture",
  "Product Title": "Product Title:",
  "Price Range": "Price Range",
  "Base Information":"Base Information",
  "Product Links": "Product Links:",
  "Product Description": "Product Description:",
  "Trade Name": "Trade Name",
  "Only matching last": "Only matching last",
  "Save Rule": "Save Rule",
  "Please select the Period": "Please select the Period",
  "Please select the vendor visibility": "Please select the vendor visibility",
  "Automatic dispatch orders setting": "Automatic dispatch orders setting",
  "Show hidden orders": "Show hidden orders",
  "Choose my all Shopify products": "Choose my all Shopify products",
  "shopify orders have been selected and can now be dispatched to your vendors": "shopify orders have been selected and can now be dispatched to your vendors",
  "Dispatch to the vendor": "Dispatch to the vendor",
  "My all Shopify products": "My all Shopify products",
  "days unfulfilled orders": "days unfulfilled orders",
  "Dispatch rule TEST": "Dispatch rule TEST",
  "THE BRIDGE CONNECTING SUPPLIERS AND YOU, MAKING DROPSHIPPING BUSINESS MORE CONVENIENT": " THE BRIDGE CONNECTING SUPPLIERS AND YOU, MAKING DROPSHIPPING BUSINESS MORE CONVENIENT",
  "Your supplier only needs to register an account to quickly build the system": "Your supplier only needs to register an account to quickly build the system",
  "One-click hosting of stores, fast synchronization of orders": "One-click hosting of stores, fast synchronization of orders",
  "Automatically synchronize logistics information": "Automatically synchronize logistics information",
  "Quick Access": "Quick Access",
  "Do you have an BCN supplier for you": "Do you have an BCN supplier for you",
  "Already have a supplier": "Already have a supplier",
  "I don't have a supplier": "I don't have a supplier",
  "Let your supplier fulfill your order more systematically, copy the link and send it to your supplier, and immediately invite your supplier to settle in,": "Let your supplier fulfill your order more systematically, copy the link and send it to your supplier, and immediately invite your supplier to settle in,",
  "2024-2024BCN All Rights Reserved": "2024-2024BCN All Rights Reserved",
  "Waiting for the payment result to be returned": "Waiting for the payment result to be returned",
  "Sorry, we can't complete the payment": "Sorry, we can't complete the payment",
  "Please check the purchase products": "Please check the purchase products",
  "After the combination payment is enabled, the account balance will be deducted first, and the rest will be paid by other selected methods": "After the combination payment is enabled, the account balance will be deducted first, and the rest will be paid by other selected methods",
  "Please select the goods first!": "Please select the goods first!",
  "Please choose the logistics channel": "Please choose the logistics channel",
  "请稍后重试～": "Please try again later ~",
  "User Name": "User Name",
  "Users login": " Users login",
  "Password": "Password",
  "Auth Status": "Auth Status",
  "All Status": "All Status",
  "Unauthorized": "Unauthorized",
  "Delete Task": "Delete Task",
  "Sale price": "Sale price",
  "Select the task": "Select the task",
  "Create a ticket": "Create a ticket",
  "Request": "Request",
  "Store name:": "Store name:",
  "No Message": "No Message",
  "Send": "Send",
  "Please enter a value greater than 0": "Please enter a value greater than 0",
  "Please enter a value less than the total amount of the order": "Please enter a value less than the total amount of the order",
  "What is your Shopify store name?": "What is your Shopify store name?",
  "Rewards QTY left": "Rewards QTY left",
  "Amount paid/Credit payment":"Amount paid/Credit payment",
  "Vender Name": " Vender Name",
  "AliExpress Shop Name": "AliExpress Shop Name",
  "Product allocated": "Product allocated",
  "Purchase amount:": "Purchase amount:",
  "Created at:": "Created at:",
  "Sourcing Now": "Sourcing Now",
  "Latest cooperation at:": "Latest cooperation at:",
  "How to add": " How to add",
  "Email Security Verification": "Email Security Verification",
  "For security reason.We need to verify your email address.Please click 'Send' to get the verification code in your inbox": "For security reason.We need to verify your email address.Please click 'Send' to get the verification code in your inbox",
  "Verify": "Verify",
  "My Wallet": "My Wallet",
  "My Balance": "My Balance",
  "brokerage":"brokerage",
  "Please enter the withdrawal amount":"Please enter the withdrawal amount",
  "tip":"tip",
  "Your Total Rewards": "Your Total Rewards",
  "orders QTY": " orders QTY",
  "We Accept": "We Accept",
  "Charging Method": "Charging Method",
  "Pay with Credit Card": "Pay with Credit Card",
  "Paypal Payment Amount": "Paypal Payment Amount",
  "The amount of each recharge must be more than 100 dollars.": "The amount of each recharge must be more than 100 dollars.",
  "Please verify your email address here,": "Please verify your email address here,",
  "Withdraw Cash": " Withdraw Cash",
  "I see": "I see",
  "Enter Verification Code": "Enter Verification Code",
  "Verify Email": "Verify Email",
  "Bill Number": "Bill Number",
  "Transfer ID": "Transfer ID",
  "wallet recharge": "wallet recharge",
  "The minimum payment is $100.": " The minimum payment is $100.",
  "Powered by": "Powered by",
  "All transactions are secure and encrypted.": "All transactions are secure and encrypted.",
  "Account Balance": "Account Balance",
  "Withdrawal amount": "Withdrawal amount",
  " We will charge you 5% fee when withdrawing.": " We will charge you 5% fee when withdrawing.",
  "Send Verification Code": "Send Verification Code",
  "The verification code will be sent to your email": "The verification code will be sent to your email",
  "Please enter your withdrawal amount": "Please enter your withdrawal amount",
  "Please enter your account": "Please enter your account",
  "Please enter your account name": "Please enter your account name",
  "Please enter the code": "Please enter the code",
  "Please enter the recharge amount": "Please enter the recharge amount",
  "The minimum payment is $100": "The minimum payment is $100",
  "The Code was sent successfully": "The Code was sent successfully",
  "Our app is now updating the page you are visiting, we will auto refresh this page in 10 seconds.": " Our app is now updating the page you are visiting, we will auto refresh this page in 10 seconds.",
  "I got it, please refresh it now": "I got it, please refresh it now",
  "Estimated start time:": "Estimated start time:",
  "Security Verification": "Security Verification",
  "We noticed you haven't verified your email address. Go to verify now?": "We noticed you haven't verified your email address. Go to verify now?",
  "We noticed you haven't bind your mobile phone. Go to complete now?": "We noticed you haven't bind your mobile phone. Go to complete now?",
  "For security reason.We need to verify your email address.": "For security reason.We need to verify your email address.",
  "Send To": "Send To",
  "Please click 'Send' to get the verification code in your inbox": "Please click 'Send' to get the verification code in your inbox",
  "afterSales": "afterSales",
  'after sales':"after sales",
  "Reason": "Reason",
  "Fulfillment Costs": "Fulfillment Costs",
  "VAT rate(Destination only in Germany)": "VAT rate(Destination only in Germany)",
  "Shipping options": "Shipping options",
  '请输入': "please enter",
  '工单号': 'Ticket No.',
  '同意': 'agree',
  "待复核": "Pending Review",
  '已确认': 'Checked',
  "售后工单": "After-sales Ticket",
  '工单类型': 'Ticket Type',
  '客户名称': "Customer Name",
  '审批': "Approval",
  "交易类型": "Transaction Type",
  "问题类型": "Question Type",
  "问题描述": "Problem Description",
  '退款': "Refund",
  '更换': "Replacement",
  "修改客户相关信息": "modify the related information for customer",
  '取消订单': "cancel order",
  '无跟踪信息': "No tracking information",
  '跟踪信息长时间未更新': "Tracking information not update too long time",
  '物品损坏': "Item damage",
  '物品丢失': "Item missing",
  '发送错误产品': "Send wrong product",
  '发送错误地址': "Send wrong address",
  '订单暂停': "On hold order",
  '选填': "optional",
  "订单信息": "Order Information",
  "第三方订单编号": "Third party order number",
  "订单编号": "Order Number",
  "店铺": "Stores",
  "创建时间": "Creation time",
  "开泰银行支付": "Kaieteur Bank Payment",
  "供应商已发货，但物流信息未同步到Shopify店铺": "The supplier has shipped, but the logistics information has not been synced to the Shopify shop.",
  "供应商已发货，物流信息已同步到Shopify店铺": "The supplier has shipped and the logistics information has been synced to the Shopify shop.",
  "您还没有选择可导出的字段。请在下方选择。": "You have not yet selected the fields that can be exported. Please select below.",
  "采购订单基础信息": "Purchase order base information",
  "订单总数": "Total number of orders",
  "订单商品项": "Order items",
  "合计商品总数": "Total goods",
  "合计采购金额": "Total purchase amount",
  "发货情况统计": "Shipment statistics",
  "已发货商品数": "Number of items shipped",
  "已发货商品额": "Amount of goods shipped",
  "未发货商品数": "Number of items not shipped",
  "未发货商品额": "Amount of unshipped goods",
  "发货率": "Shipment rate",
  "不发货商品数": "Number of items not shipped",
  "不发货商品额": "Amount of non-delivery items",
  "当前发票页面仅供预览，如果发送给客户请使用发票编辑页面的'发送发票'功能！": "The current invoice page is for preview purposes only, if you are sending to a customer please use the 'Send Invoice' function on the invoice editing page",
  "发票预览": "Invoice Preview",
  "如图一所示:页面顶部“发送发票”按钮": "As shown in Figure 1: 'Send Invoice' button at the top of the page",
  "如图二所示:页面底部'发送发票'按钮": "As shown in Figure 2: 'Send Invoice' button at the bottom of the page",
  "商品列表页": "Product list page",
  "底部": "Bottom",
  "顶部": "Top",
  "请输入单号范围": "Please enter the single number range",
  "起始单号必须小于结束单号": "The starting order number must be less than the ending order number",
  "确定删除该商品？": "Sure to delete this item?",
  "确定": "OK",
  "取消": "Cancel",
  "已取消": "Canceled",
  "选取文件": "Select file",
  "点击下载": "Click to download",
  "订单导入模板": "Order Import Template",
  "请按规范填写表格，仅支持xlsx格式文件": " Please fill in the form according to the specification, only xlsx format files are supported",
  "上传的文件不能超过2M，只处理前99条数据": "The uploaded file cannot exceed 2M, and only the first 99 data are processed",
  '待审核': 'Await Review',
  '待确认': 'Await Check',
  '通过': 'Pass',
  '拒绝': 'Reject',
  '申诉': 'Appeal',
  "余额":"balance",
  "线下":"offline",
  "提现方式":"Withdrawal method",
  "状态": 'Approval Status',
  '警告提示': 'Warning Tips',
  '该分类下目前还没有商品': 'There are currently no products under this category',
  '最大建议尺寸 200px * 200px, 图片可自适应': 'Maximum recommended size 200px * 200px, image can be adaptive',
  '添加图片': 'add image',
  '更改': 'change',
  '删除': 'delete',
  '请联系供应商，完善站长外部编号': 'Please contact the supplier to improve the external number of the webmaster',
  '返回': 'Back',
  "上传图片大小不能超过 500kb!": "The size of the uploaded image should not exceed 500kb!",
  "描述文字": "Description text",
  "履行费用": "Fulfilment costs",
  "发货时效": "Shipping time",


  "Pause": "Pause",
  "productType": "Product Type",
  "platform": "Platform",
  "Operation": "Operation",
  "Open in website": "Open in website",
  "Edit on Dashboard": "Edit on Dashboard",
  "Split orders": "Split orders",
  "Reply date": "Reply date",
  "null Please make an offer": "null Please make an offer",

  "Yes": "Yes",
  "No": "No",
  "Are you sure?": "Are you sure?",
  "After-sales Service": "After-sales Service",
  "Deal Type": "Deal Type",

  "Damaged Item": "Damaged Item",
  "Wrong product": "Wrong product",
  "The client received the order?": "The client received the order?",
  "Whats happend?": "Whats happend?",
  "Please select type first.": "Please select type first.",
  "You can modify your order dispatch rules at any time in the menu 'My Orders >> Dispatch settings'": "You can modify your order dispatch rules at any time in the menu 'My Orders >> Dispatch settings'",

  "Comexbcn Privacy Statement": "Comexbcn Privacy Statement",
  "How Comexbcn Uses Your Data": "How Comexbcn Uses Your Data",
  "This statement demonstrates how seriously and responsibly we handle user privacy.": "This statement demonstrates how seriously and responsibly we handle user privacy.",
  "It details to the user how our company, COMEXBCN, collects, handles, shares, and processes their data and/or information.": "It details to the user how our company, COMEXBCN, collects, handles, shares, and processes their data and/or information.",
  "This page alerts and informs the user that by choosing our service and app/website,": "This page alerts and informs the user that by choosing our service and app/website,",
  "they agree to the use, collection, and processing of dropshipping by Comexbcn,": "they agree to the use, collection, and processing of dropshipping by Comexbcn,",
  "and also that they accept all the “TERMS AND CONDITIONS”.": "and also that they accept all the “TERMS AND CONDITIONS”.",
  "Any personal information may be used to help improve our app/website.": "Any personal information may be used to help improve our app/website.",
  "Collection and Use of Information": "Collection and Use of Information",
  "If you use our app/website, we may request that you provide personal identification data.": "If you use our app/website, we may request that you provide personal identification data.",
  "This is not limited to the name for full use of our app/website's functions.": "This is not limited to the name for full use of our app/website's functions.",
  "We also intend to use the data for “marketing activities” and for conducting general research and evaluations.": "We also intend to use the data for “marketing activities” and for conducting general research and evaluations.",
  "Values": "Values",
  "Recognition of the nature of our business and your information": "Recognition of the nature of our business and your information",
  "We perform a legally authorized service to provide services.": "We perform a legally authorized service to provide services.",
  "Our commitment is to integrity, transparency, and respect for privacy in all aspects.": "Our commitment is to integrity, transparency, and respect for privacy in all aspects.",
  "We will process and use only essential information for our business,": "We will process and use only essential information for our business,",
  "with personal data belonging solely and exclusively to the user,": "with personal data belonging solely and exclusively to the user,",
  "thus respecting its nature and treating it sensitively in every detail.": "thus respecting its nature and treating it sensitively in every detail.",
  "Protecting Your Information": "Protecting Your Information",
  "For any third-party requests requiring your information,": "For any third-party requests requiring your information,",
  "our company will only provide it with the user’s consent,": "our company will only provide it with the user’s consent,",
  "without any sharing with external sources,": "without any sharing with external sources,",
  "unless obligated to comply with applicable laws and regulations,": "unless obligated to comply with applicable laws and regulations,",
  "responding to an official subpoena, or any other judicial request,": "responding to an official subpoena, or any other judicial request,",
  "seeking to protect our user and also our rights.": "seeking to protect our user and also our rights.",
  "Usability Rights": "Usability Rights",

  "Comexbcn is focused on prevention, striving to avoid errors in its procedures as much as possible. However, if there is any situation where a cancellation and return are desired, our policy for taking appropriate actions is described below.": "Comexbcn is focused on prevention, striving to avoid errors in its procedures as much as possible. However, if there is any situation where a cancellation and return are desired, our policy for taking appropriate actions is described below.",
  "Cancellation": "Cancellation",
  "We accept cancellation requests before the product is shipped or produced. In this case, a full refund will be issued. If the product has already been shipped, it cannot be canceled.": "We accept cancellation requests before the product is shipped or produced. In this case, a full refund will be issued. If the product has already been shipped, it cannot be canceled.",
  "Returns": "Returns",
  "Respecting the consumer's right to request a return within 10 days after the product's delivery, we accept returns under the condition that the item or items are not in use and are in their original delivery packaging. Our customer service department will request the receipt or proof of purchase to certify the procedure so that the shipment can be made to the correct address.": "Respecting the consumer's right to request a return within 10 days after the product's delivery, we accept returns under the condition that the item or items are not in use and are in their original delivery packaging. Our customer service department will request the receipt or proof of purchase to certify the procedure so that the shipment can be made to the correct address.",
  "Items that are damaged or lost qualify for a full refund, or another item of the same order can be sent under the same conditions, or the corresponding value of the claimed item can be refunded.": "Items that are damaged or lost qualify for a full refund, or another item of the same order can be sent under the same conditions, or the corresponding value of the claimed item can be refunded.",
  "Refund Process": "Refund Process",
  "After receiving the item and performing the check as indicated above, we will notify you of the receipt and the processing time for the refund. A credit of the agreed amount will be issued as agreed between the parties via email, indicating the time frame to complete the process.": "After receiving the item and performing the check as indicated above, we will notify you of the receipt and the processing time for the refund. A credit of the agreed amount will be issued as agreed between the parties via email, indicating the time frame to complete the process.",
  "For any clarifications, please contact our support at: contato@comexbcn.com with your contact information, indicating the purchased item.": "For any clarifications, please contact our support at: contato@comexbcn.com with your contact information, indicating the purchased item.",

  'This application/site is managed by the Comexbcn team. They are responsible for all management, and whenever we use the words "we," "together," and "our," they refer to this team at app.comexbcn.com, including tools, information, and services. Any user who accesses our site and application is conditioned to accept our terms and conditions of use, company policies, and notices mentioned here.':
      'This application/site is managed by the Comexbcn team. They are responsible for all management, and whenever we use the words "we," "together," and "our," they refer to this team at app.comexbcn.com, including tools, information, and services. Any user who accesses our site and application is conditioned to accept our terms and conditions of use, company policies, and notices mentioned here.',
  'By visiting our application and/or site, purchasing on our platform, you declare that you are engaging in our "Service" and agree to comply with our following terms and conditions of use ("TERMS AND CONDITIONS OF USE"), including additional terms, conditions, and policies referenced here or available via link. These TERMS AND CONDITIONS OF USE apply to users in their entirety on the site or application, without limitation, users who browse, suppliers, customers, merchants, and/or content collaborators.': 'By visiting our application and/or site, purchasing on our platform, you declare that you are engaging in our "Service" and agree to comply with our following terms and conditions of use ("TERMS AND CONDITIONS OF USE"), including additional terms, conditions, and policies referenced here or available via link. These TERMS AND CONDITIONS OF USE apply to users in their entirety on the site or application, without limitation, users who browse, suppliers, customers, merchants, and/or content collaborators.',
  'Please read our TERMS AND CONDITIONS OF USE carefully before accessing or using our site/application. By accessing any content on our site/application, you agree to comply with these TERMS AND CONDITIONS OF USE. If you do not agree with our terms and conditions, you may not access our site/application or use any of our services. If these TERMS AND CONDITIONS OF USE are considered an offer, their acceptance is expressly limited to these TERMS AND CONDITIONS.': 'Please read our TERMS AND CONDITIONS OF USE carefully before accessing or using our site/application. By accessing any content on our site/application, you agree to comply with these TERMS AND CONDITIONS OF USE. If you do not agree with our terms and conditions, you may not access our site/application or use any of our services. If these TERMS AND CONDITIONS OF USE are considered an offer, their acceptance is expressly limited to these TERMS AND CONDITIONS.',
  "Any new feature or tool that is added will also be subject to our terms and conditions. The most recent version of this will always be available on this page. Comexbcn reserves the right to update, delete, or modify any part of the TERMS AND CONDITIONS OF USE by posting updates on our site/application. It is the user's responsibility to check this page to monitor our updates. Your access and use of our site/application constitute your acceptance of these changes.": "Any new feature or tool that is added will also be subject to our terms and conditions. The most recent version of this will always be available on this page. Comexbcn reserves the right to update, delete, or modify any part of the TERMS AND CONDITIONS OF USE by posting updates on our site/application. It is the user's responsibility to check this page to monitor our updates. Your access and use of our site/application constitute your acceptance of these changes.",
  'SECTION 1 – APPLICATION/SITE TERMS OF USE': 'SECTION 1 – APPLICATION/SITE TERMS OF USE',
  'By agreeing to these TERMS AND CONDITIONS, you may not use the products advertised on the application/site for any illegal or unauthorized purpose, nor may you, under any circumstances, violate any laws in your jurisdiction (including but not limited to copyright laws).': 'By agreeing to these TERMS AND CONDITIONS, you may not use the products advertised on the application/site for any illegal or unauthorized purpose, nor may you, under any circumstances, violate any laws in your jurisdiction (including but not limited to copyright laws).',
  'You must not transmit any worms or viruses or any code of a destructive nature. Violation of any of the Terms will result in the immediate termination of your Services.': 'You must not transmit any worms or viruses or any code of a destructive nature. Violation of any of the Terms will result in the immediate termination of your Services.',
  'SECTION 2 – GENERAL CONDITIONS': 'SECTION 2 – GENERAL CONDITIONS',
  'We reserve the right to refuse service to anyone for any reason at any time. You understand that your content (excluding credit card information) may be transferred unencrypted and involve (a) transmissions over various networks; and (b) changes to conform and adapt to technical requirements of connecting networks or devices. Credit card information is always encrypted during transfer over networks.': 'We reserve the right to refuse service to anyone for any reason at any time. You understand that your content (excluding credit card information) may be transferred unencrypted and involve (a) transmissions over various networks; and (b) changes to conform and adapt to technical requirements of connecting networks or devices. Credit card information is always encrypted during transfer over networks.',
  'You agree not to reproduce, duplicate, copy, sell, resell, or exploit any part of the Service, use of the Service, or access to the Service or any contact on the site/application through which the service is provided, without express written permission from us.': 'You agree not to reproduce, duplicate, copy, sell, resell, or exploit any part of the Service, use of the Service, or access to the Service or any contact on the site/application through which the service is provided, without express written permission from us.',
  'The headings used in this agreement are included for convenience only and will not limit or otherwise affect these Terms.': 'The headings used in this agreement are included for convenience only and will not limit or otherwise affect these Terms.',
  'SECTION 3 – ACCURACY AND COMPLETENESS OF INFORMATION': 'SECTION 3 – ACCURACY AND COMPLETENESS OF INFORMATION',
  'We are not responsible if the information provided here is not accurate, complete, or current. All material provided is for general information purposes only and should not be relied upon for making decisions without consulting primary information sources. Any reliance on the content provided is at your own risk.': 'We are not responsible if the information provided here is not accurate, complete, or current. All material provided is for general information purposes only and should not be relied upon for making decisions without consulting primary information sources. Any reliance on the content provided is at your own risk.',
  'This site may contain historical information, which is provided for your reference. We reserve the right to modify any document or information on this application/site at any time, without obligation to update any information on this page, and you agree that it is your responsibility to monitor any changes.': 'This site may contain historical information, which is provided for your reference. We reserve the right to modify any document or information on this application/site at any time, without obligation to update any information on this page, and you agree that it is your responsibility to monitor any changes.',
  'SECTION 4 – MODIFICATIONS TO PRICES AND SERVICES': 'SECTION 4 – MODIFICATIONS TO PRICES AND SERVICES',
  'We reserve the right to change the prices of our products without notice at any time or to discontinue the service or any part of it without notice at any time. We shall not be liable to you or any third party for any modification, price change, or discontinuation of the service.': 'We reserve the right to change the prices of our products without notice at any time or to discontinue the service or any part of it without notice at any time. We shall not be liable to you or any third party for any modification, price change, or discontinuation of the service.',
  'SECTION 5 – PRODUCTS OR SERVICES (if applicable)': 'SECTION 5 – PRODUCTS OR SERVICES (if applicable)',
  'Certain products or services may be available exclusively through the application/site. We also reserve the right to limit quantities and apply return and exchange policies in accordance with our policy.': 'Certain products or services may be available exclusively through the application/site. We also reserve the right to limit quantities and apply return and exchange policies in accordance with our policy.',
  'We strive to display products as accurately as possible in terms of sizes and colors, but we cannot guarantee that the display of any color on your computer monitor will be accurate. We reserve the right to limit our products to any person, geographic region, or jurisdiction. We do not warrant that the quality of any products, services, information, or other materials purchased by you will meet your expectations, or that any errors in the service will be corrected.': 'We strive to display products as accurately as possible in terms of sizes and colors, but we cannot guarantee that the display of any color on your computer monitor will be accurate. We reserve the right to limit our products to any person, geographic region, or jurisdiction. We do not warrant that the quality of any products, services, information, or other materials purchased by you will meet your expectations, or that any errors in the service will be corrected.',
  'SECTION 6 – BILLING AND ACCOUNT INFORMATION': 'SECTION 6 – BILLING AND ACCOUNT INFORMATION',
  'We reserve the right to refuse any order you place with us. We may, at our sole discretion, limit or cancel quantities purchased per person, per household, or per order. These restrictions may include orders placed by or under the same customer account, the same credit card, and/or orders that use the same billing and/or shipping address. In the event we make a change to or cancel an order, we may attempt to notify you by contacting the email and/or billing address/phone number provided at the time the order was made. We reserve the right to limit or prohibit orders that, in our sole judgment, appear to be placed by dealers, resellers, or distributors.': 'We reserve the right to refuse any order you place with us. We may, at our sole discretion, limit or cancel quantities purchased per person, per household, or per order. These restrictions may include orders placed by or under the same customer account, the same credit card, and/or orders that use the same billing and/or shipping address. In the event we make a change to or cancel an order, we may attempt to notify you by contacting the email and/or billing address/phone number provided at the time the order was made. We reserve the right to limit or prohibit orders that, in our sole judgment, appear to be placed by dealers, resellers, or distributors.',
  'You agree to provide current, complete, and accurate purchase and account information for all purchases made at our store. You agree to promptly update your account and other information, including your email address and credit card numbers and expiration dates, so that we can complete your transactions and contact you as needed. For more details, please review our Return Policy.': 'You agree to provide current, complete, and accurate purchase and account information for all purchases made at our store. You agree to promptly update your account and other information, including your email address and credit card numbers and expiration dates, so that we can complete your transactions and contact you as needed. For more details, please review our Return Policy.',
  'SECTION 7 – OPTIONAL TOOLS': 'SECTION 7 – OPTIONAL TOOLS',
  'We may provide you with access to third-party tools over which we neither monitor nor have any control or input. You acknowledge and agree that we provide access to such tools "as is" and "as available" without any warranties, representations, or conditions of any kind and without any endorsement. Any use by you of optional tools offered through the site/application is entirely at your own risk and discretion, and you should ensure that you are familiar with and approve the terms on which tools are provided by the relevant third-party provider. We may also, in the future, offer new services and/or features through the site/application (including the release of new tools and resources). Such new features and/or services shall also be subject to these TERMS AND CONDITIONS.': 'We may provide you with access to third-party tools over which we neither monitor nor have any control or input. You acknowledge and agree that we provide access to such tools "as is" and "as available" without any warranties, representations, or conditions of any kind and without any endorsement. Any use by you of optional tools offered through the site/application is entirely at your own risk and discretion, and you should ensure that you are familiar with and approve the terms on which tools are provided by the relevant third-party provider. We may also, in the future, offer new services and/or features through the site/application (including the release of new tools and resources). Such new features and/or services shall also be subject to these TERMS AND CONDITIONS.',
  'SECTION 8 – PERSONAL INFORMATION': 'SECTION 8 – PERSONAL INFORMATION',
  'Your submission of personal information is governed by our Privacy Policy, following all applicable laws and regulations.': 'Your submission of personal information is governed by our Privacy Policy, following all applicable laws and regulations.',
  'SECTION 9 – DISCLAIMER OF WARRANTIES; LIMITATION OF LIABILITY': 'SECTION 9 – DISCLAIMER OF WARRANTIES; LIMITATION OF LIABILITY',
  'We do not guarantee, represent, or warrant that your use of our service will be uninterrupted, timely, secure, or error-free.': 'We do not guarantee, represent, or warrant that your use of our service will be uninterrupted, timely, secure, or error-free.',
  'We do not warrant that the results that may be obtained from the use of the service will be accurate or reliable.': 'We do not warrant that the results that may be obtained from the use of the service will be accurate or reliable.',
  'You agree that from time to time we may remove the service for indefinite periods or cancel the service at any time, without notice to you.': 'You agree that from time to time we may remove the service for indefinite periods or cancel the service at any time, without notice to you.',
  "You expressly agree that your use of, or inability to use, the service is at your sole risk. The service and all products and services delivered to you through the service are (except as expressly stated by us) provided 'as is' and 'as available' for your use, without any representation, warranties, or conditions of any kind, either express or implied, including all implied warranties or conditions of merchantability, merchantable quality, fitness for a particular purpose, durability, title, and non-infringement.": "You expressly agree that your use of, or inability to use, the service is at your sole risk. The service and all products and services delivered to you through the service are (except as expressly stated by us) provided 'as is' and 'as available' for your use, without any representation, warranties, or conditions of any kind, either express or implied, including all implied warranties or conditions of merchantability, merchantable quality, fitness for a particular purpose, durability, title, and non-infringement.",
  'In no case shall we, our directors, officers, employees, affiliates, agents, contractors, interns, suppliers, service providers, or licensors be liable for any injury, loss, claim, or any direct, indirect, incidental, punitive, special, or consequential damages of any kind, including, without limitation lost profits, lost revenue, lost savings, loss of data, replacement costs, or any similar damages, whether based in contract, tort (including negligence), strict liability or otherwise, arising from your use of any of the service or any products procured using the service, or for any other claim related in any way to your use of the service or any product, including, but not limited to, any errors or omissions in any content, or any loss or damage of any kind incurred as a result of the use of the service or any content (or product) posted, transmitted, or otherwise made available via the service, even if advised of their possibility. Because some states or jurisdictions do not allow the exclusion or limitation of liability for consequential or incidental damages, in such states or jurisdictions, our liability shall be limited to the maximum extent permitted by law.': 'In no case shall we, our directors, officers, employees, affiliates, agents, contractors, interns, suppliers, service providers, or licensors be liable for any injury, loss, claim, or any direct, indirect, incidental, punitive, special, or consequential damages of any kind, including, without limitation lost profits, lost revenue, lost savings, loss of data, replacement costs, or any similar damages, whether based in contract, tort (including negligence), strict liability or otherwise, arising from your use of any of the service or any products procured using the service, or for any other claim related in any way to your use of the service or any product, including, but not limited to, any errors or omissions in any content, or any loss or damage of any kind incurred as a result of the use of the service or any content (or product) posted, transmitted, or otherwise made available via the service, even if advised of their possibility. Because some states or jurisdictions do not allow the exclusion or limitation of liability for consequential or incidental damages, in such states or jurisdictions, our liability shall be limited to the maximum extent permitted by law.',
  'SECTION 10 – TERMINATION OF SERVICE': 'SECTION 10 – TERMINATION OF SERVICE',
  'You may terminate this agreement at any time by notifying us that you no longer wish to use our services or when you cease using our site/application. Both parties may terminate this agreement at any time, and any charges or other information and pending procedures will be handled directly by the contract termination department.': 'You may terminate this agreement at any time by notifying us that you no longer wish to use our services or when you cease using our site/application. Both parties may terminate this agreement at any time, and any charges or other information and pending procedures will be handled directly by the contract termination department.',
  'SECTION 11 – CUSTOMER SERVICE': 'SECTION 11 – CUSTOMER SERVICE',
  'You will always have access to our customer service, whether by email, online chat on our site/application, or via our WhatsApp number. It is your responsibility to contact us whenever you have any questions or situations that may compromise your data or the processing of your information on our site/application. Response times vary depending on the inquiry sent, between 48 to 72 business hours.': 'You will always have access to our customer service, whether by email, online chat on our site/application, or via our WhatsApp number. It is your responsibility to contact us whenever you have any questions or situations that may compromise your data or the processing of your information on our site/application. Response times vary depending on the inquiry sent, between 48 to 72 business hours.',
  'SECTION 12 – SHIPPING': 'SECTION 12 – SHIPPING',
  'Logistics and shipment policies are covered in our Shipping Policy, following all applicable laws and regulations.': 'Logistics and shipment policies are covered in our Shipping Policy, following all applicable laws and regulations.',
  'SECTION 13 – GOVERNING LAW': 'SECTION 13 – GOVERNING LAW',
  'These TERMS AND CONDITIONS and any separate agreements whereby we provide you Services shall be governed by and construed in accordance with the laws of Hong Kong.': 'These TERMS AND CONDITIONS and any separate agreements whereby we provide you Services shall be governed by and construed in accordance with the laws of Hong Kong.',
  'SECTION 14 – CHANGES TO TERMS AND CONDITIONS': 'SECTION 14 – CHANGES TO TERMS AND CONDITIONS',
  'You can review the most current version of the TERMS AND CONDITIONS OF USE at any time on this page. We reserve the right to update, change, or replace any part of': 'You can review the most current version of the TERMS AND CONDITIONS OF USE at any time on this page. We reserve the right to update, change, or replace any part of',

  "Thank you for your interest in Comexbcn.": "Thank you for your interest in Comexbcn.",
  "Our commitment is to deliver quality service with transparency and efficiency, offering various shipping options worldwide. We have a decade of experience in this field, with hundreds of satisfied customers.": "Our commitment is to deliver quality service with transparency and efficiency, offering various shipping options worldwide. We have a decade of experience in this field, with hundreds of satisfied customers.",
  "Below are the terms and conditions of our shipping policy.": "Below are the terms and conditions of our shipping policy.",
  "1. Processing and Shipping Time": "1. Processing and Shipping Time",
  "Processing time is typically between 2 to 4 days after payment confirmation. During this period, we will prepare your order.": "Processing time is typically between 2 to 4 days after payment confirmation. During this period, we will prepare your order.",
  "If there are any irregularities, we will contact you.": "If there are any irregularities, we will contact you.",
  "2.1 International Shipping": "2.1 International Shipping",
  "Comexbcn offers international shipping. For any questions, please contact us through [our website](https://www.comexbcn.com).": "Comexbcn offers international shipping. For any questions, please contact us through [our website](https://www.comexbcn.com).",
  "Delivery Estimates and Applicable Fees": "Delivery Estimates and Applicable Fees",
  "We understand the importance of knowing the best market practices to minimize costs without compromising service quality. Comexbcn operates with transparency, providing realistic deadlines to avoid surprises during the process. Before finalizing your order, all timelines and costs will be available for your review. The delivery period starts from the moment the shipment is dispatched, not the order date. It's important to note that delivery estimates are not guaranteed. We do our best to meet your order requirements, but unexpected situations such as weather changes, attacks, force majeure, and other external events can delay delivery.": "We understand the importance of knowing the best market practices to minimize costs without compromising service quality. Comexbcn operates with transparency, providing realistic deadlines to avoid surprises during the process. Before finalizing your order, all timelines and costs will be available for your review. The delivery period starts from the moment the shipment is dispatched, not the order date. It's important to note that delivery estimates are not guaranteed. We do our best to meet your order requirements, but unexpected situations such as weather changes, attacks, force majeure, and other external events can delay delivery.",
  "3.1 Delivery Observations": "3.1 Delivery Observations",
  "a. The delivery date may vary depending on the carrier, delivery method, location, and items ordered.": "a. The delivery date may vary depending on the carrier, delivery method, location, and items ordered.",
  "b. Separate Product Deliveries": "b. Separate Product Deliveries",
  "Products may be delivered separately. When placing your order, please consider these factors for the estimated delivery date.": "Products may be delivered separately. When placing your order, please consider these factors for the estimated delivery date.",
  "Transit Time:The time it takes for your shipment to move from our distribution center to the local carrier.": "Transit Time:The time it takes for your shipment to move from our distribution center to the local carrier.",
  "Shipment Weight:Shipping costs are based on the weight of your package and the chosen delivery method.": "Shipment Weight:Shipping costs are based on the weight of your package and the chosen delivery method.",
  "The final cost of your order can be seen after proceeding to the final checkout screen. Shipping costs will be displayed when you finalize your order.": "The final cost of your order can be seen after proceeding to the final checkout screen. Shipping costs will be displayed when you finalize your order.",
  "Tracking": "Tracking",
  "As previously mentioned, Comexbcn operates transparently and always opts for tracked shipping to ensure peace of mind throughout the process. After completing a purchase with us, you will have access to tracking your order.": "As previously mentioned, Comexbcn operates transparently and always opts for tracked shipping to ensure peace of mind throughout the process. After completing a purchase with us, you will have access to tracking your order.",
  "Damages": "Damages",
  "If you notice any damage upon delivery, please contact us promptly through our WhatsApp support or via our [website](https://www.comexbcn.com).": "If you notice any damage upon delivery, please contact us promptly through our WhatsApp support or via our [website](https://www.comexbcn.com).",
  "Lost Package": "Lost Package",
  "While rare, if a package is lost, please check possible locations where the delivery person might have left it, including with neighbors. Before contacting us, we kindly ask you to check all possible locations to avoid unnecessary steps. If you still cannot locate the package, contact us via [our website](https://www.comexbcn.com) to report the lost package.": "While rare, if a package is lost, please check possible locations where the delivery person might have left it, including with neighbors. Before contacting us, we kindly ask you to check all possible locations to avoid unnecessary steps. If you still cannot locate the package, contact us via [our website](https://www.comexbcn.com) to report the lost package.",
  "Miscellaneous Questions": "Miscellaneous Questions",
  "For any questions not mentioned here, please do not hesitate to contact us. We also have a FAQ page that may be useful for your situation. Visit our website: [www.comexbcn.com](https://www.comexbcn.com).": "For any questions not mentioned here, please do not hesitate to contact us. We also have a FAQ page that may be useful for your situation. Visit our website: [www.comexbcn.com](https://www.comexbcn.com).",

  "正在处理中，请勿重复操作": "Processing in progress, please avoid duplicate actions.",

  "Provide product link": "Provide product link",
  "Remove All": "Remove All",
  "Vendor quoted order": "Vendor quoted order",
  "Real Paid": "Real Paid",
  "SKU": "SKU",
  "Oops, no data found! Try a different search or check back later.": "Oops, no data found! Try a different search or check back later.",

  "Item Amount": "Item Amount",
  "Discount Amount": "Discount Amount",
  "CreatedAt": "PaidAt",
  "PaidAt": "PurchaseAt",
  "DeliverAt": "ShippedAt",
  "Contact Information": "Contact Information",
  "Zipcode": "Zipcode",
  "Phone number": "Phone number",
  "E-mail": "E-mail",
  "Track Company": "Track Company",
  "Notes": "Notes",
  "Apartment, sulte": "Apartment, sulte",
  "Name": "Name",
  "Contacts": "Contacts",
  "Time": "Time",
  "Goods Name": "Name",
  "Goods Property": "Perperty",
  "Shipping address": "Shipping address",

  "Re-quote": "Re-quote",
  "Restore": "Restore",
  "Help": "Help",
  "Affiliates InvitationLink": "Affiliates InvitationLink",
  "Invitation Link": "Invitation Link",
  "Offline Order": "Offline Order",
  "Offline Orders": "Offline Quotes",
  "Add New One": "Add New One",
  "Dropshipping": "Dropshipping",
  "Cargo": "CARGO",
  "Price Expect": "Price Expect",
  "Pictures": "Pictures",
  "COMPLETED": "COMPLETED",
  "FAIL": "FAIL",
  "Wait For Quote": "Not Quoted yet",
  "At least one image is required.": "At least one image is required.",
  "Max 5 images allowed.": "Max 5 images allowed.",
  "Title is required.": "Title is required.",
  "Country is required.": "Country is required.",
  "Minimum price is required.": "Minimum price is required.",
  "Maximum price is required.": "Maximum price is required.",
  "Link": "Link",
  "Issue Type": "Issue Type",
  "General Inquiry": "General Inquiry",
  "Order Issue": "Order Issue",
  "Billing/Payment": "Billing/Payment",
  "Account Support": "Account Support",
  "Product Feedback": "Product Feedback",
  "Complaint": "Complaint",
  "Other": "Other",

  "Min": "Min",
  "Max": "Max",
  "Collapse": "Collapse",
  "Access Control": "Access Control",
  "Access Control Cards": "Access Control Cards",
  "Access Control Kits": "Access Control Kits",
  "Accessories": "Accessories",
  "Accessories & Others": "Accessories & Others",
  "Accessories & Parts": "Accessories & Parts",
  "Acetate Frames": "Acetate Frames",
  "Action & Toy Figures": "Action & Toy Figures",
  "Action Figure": "Action Figure",
  "Active Bras": "Active Bras",
  "Activity & Gear": "Activity & Gear",
  "Add On Cards & Controller Panels": "Add On Cards & Controller Panels",
  "Adhesive Paper": "Adhesive Paper",
  "Adhesives": "Adhesives",
  "Advanced Storage & RAM": "Advanced Storage & RAM",
  "Africa Clothing": "Africa Clothing",
  "African American Wigs": "African American Wigs",
  "Air Cooler": "Air Cooler",
  "Air Intake & Fuel Delivery": "Air Intake & Fuel Delivery",
  "Air Intake Systems": "Air Intake Systems",
  "Air Purifier": "Air Purifier",
  "Air Quality": "Air Quality",
  "Alarm Sensor": "Alarm Sensor",
  "Alarm System Kit": "Alarm System Kit",
  "Animal Figure": "Animal Figure",
  "Animal Print Shoulder Bag": "Animal Print Shoulder Bag",
  "Ankle Boots": "Ankle Boots",
  "Anti-Theft Backpack": "Anti-Theft Backpack",
  "Apparels": "Apparels",
  "Aquarium Accessories & Equipment": "Aquarium Accessories & Equipment",
  "Aquarium Decors": "Aquarium Decors",
  "Aquarium Lights": "Aquarium Lights",
  "Aquarium Pumps & Filters": "Aquarium Pumps & Filters",
  "Aquariums & Fish Bowls": "Aquariums & Fish Bowls",
  "Art Supplies": "Art Supplies",
  "Artificial Flower": "Artificial Flower",
  "Asia & Pacific lslands Clothing": "Asia & Pacific Islands Clothing",
  "ATV & UTV Accessories": "ATV & UTV Accessories",
  "Auto Fasteners & Clips": "Auto Fasteners & Clips",
  "Automatic Feeders": "Automatic Feeders",
  "Automatic lrrigation Equipment": "Automatic Irrigation Equipment",
  "Automatic lrrigation System": "Automatic Irrigation System",
  "Automation Kits": "Automation Kits",
  "Automobile Filter": "Automobile Filter",
  "Automotive & Motorcycle": "Automotive & Motorcycle",
  "Aviator jacket": "Aviator Jacket",
  "Axe": "Axe",
  "Babies & Kids": "Babies & Kids",
  "Baby & Kids' Floats": "Baby & Kids' Floats",
  "Baby Bottoms": "Baby Bottoms",
  "Baby Care": "Baby Care",
  "Baby Care Tools": "Baby Care Tools",
  "Baby Clothing": "Baby Clothing",
  "Baby Cribs": "Baby Cribs",
  "Baby Dresses": "Baby Dresses",
  "Baby Food Mills": "Baby Food Mills",
  "Baby Food Storage": "Baby Food Storage",
  "Baby Health Care": "Baby Health Care",
  "Baby Monitor": "Baby Monitor",
  "Baby Pillow & Cases": "Baby Pillow & Cases",
  "Baby Playpens": "Baby Playpens",
  "Baby Seats & Sofas": "Baby Seats & Sofas",
  "Baby Shoes": "Baby Shoes",
  "Baby Soap": "Baby Soap",
  "Baby Swimwears": "Baby Swimwears",
  "Baby Toothbrushes": "Baby Toothbrushes",
  "Baby Tops": "Baby Tops",
  "Baby Wet Wipes": "Baby Wet Wipes",
  "Backpacks": "Backpacks",
  "Backpacks & Carriers": "Backpacks & Carriers",
  "Badminton": "Badminton",
  "Bag Accessories": "Bag Accessories",
  "Baggy Jeans": "Baggy Jeans",
  "Baggy Pants": "Baggy Pants",
  "Bags": "Bags",
  "Bagutte Bag": "Baguette Bag",
  "Bandanas & Nightcaps": "Bandanas & Nightcaps",
  "Bangs": "Bangs",
  "Bar Stools": "Bar Stools",
  "Bar Tables": "Bar Tables",
  "Barebone & Mini Pc": "Barebone & Mini PC",
  "Baseball Caps": "Baseball Caps",
  "Baseball Uniform": "Baseball Uniform",
  "Basket": "Basket",
  "Bath Toys": "Bath Toys",
  "Bathroom": "Bathroom",
  "Bathroom Fixtures": "Bathroom Fixtures",
  "Bathroom Hardwares": "Bathroom Hardware",
  "Bathroom Sinks": "Bathroom Sinks",
  "Bathtub Faucets": "Bathtub Faucets",
  "Bathtubs &Accessories": "Bathtubs & Accessories",
  "Batteries": "Batteries",
  "Beach Chairs": "Beach Chairs",
  "Beach Sand Toys": "Beach Sand Toys",
  "Beaded Necklace": "Beaded Necklace",
  "Beard": "Beard",
  "Beauty & Health": "Beauty & Health",
  "Bed Linens": "Bed Linens",
  "Bedding Basics": "Bedding Basics",
  "Bedding Sets": "Bedding Sets",
  "Bedroom": "Bedroom",
  "Bedroom Furniture": "Bedroom Furniture",
  "Beds & Furnitures": "Beds & Furniture",
  "Bedspreads & Coverlets": "Bedspreads & Coverlets",
  "Belly Button Ring": "Belly Button Ring",
  "Belly Dancing": "Belly Dancing",
  "Belt Accessories": "Belt Accessories",
  "Belts": "Belts",
  "Bending Machinery": "Bending Machinery",
  "Bespoke Occasion Dresses": "Bespoke Occasion Dresses",
  "Bespoke Wedding Dress": "Bespoke Wedding Dress",
  "Bicycle Bottle Holder": "Bicycle Bottle Holder",
  "Bicycle Protective Gear": "Bicycle Protective Gear",
  "Bicycle Sticker": "Bicycle Sticker",
  "Bikinis Sets": "Bikini Sets",
  "Binder Paper": "Binder Paper",
  "Bird Diapers": "Bird Diapers",
  "Birdcage Accessories": "Birdcage Accessories",
  "Birds": "Birds",
  "Birthday & Balloon": "Birthday & Balloon",
  "BJD Dolls": "BJD Dolls",
  "Blankets & Swaddles": "Blankets & Swaddles",
  "Blazer & Suits": "Blazer & Suits",
  "Blazers": "Blazers",
  "Blocks": "Blocks",
  "Blue Light Blocking Glasses": "Blue Light Blocking Glasses",
  "Board Card": "Board Card",
  "Board Game": "Board Game",
  "Board Shorts": "Board Shorts",
  "Boat Accessories": "Boat Accessories",
  "Boat Shoes": "Boat Shoes",
  "Body & Frames": "Body & Frames",
  "Body Jewelry": "Body Jewelry",
  "Body Shaping Massage Equipment": "Body Shaping Massage Equipment",
  "Body Worn Camera": "Body Worn Camera",
  "Bodychain": "Bodychain",
  "Bodysuits": "Bodysuits",
  "Book Cover": "Book Cover",
  "Boots": "Boots",
  "Boston Bag": "Boston Bag",
  "Bottles": "Bottles",
  "Bottoms": "Bottoms",
  "Bow Ties": "Bow Ties",
  "Boxers & Briefs": "Boxers & Briefs",
  "Boxes": "Boxes",
  "Bracelet & Bangles": "Bracelet & Bangles",
  "Bras": "Bras",
  "Breifcases": "Briefcases",
  "Briefs": "Briefs",
  "Brooches": "Brooches",
  "Brushed jeans": "Brushed Jeans",
  "Bucket Bag": "Bucket Bag",
  "Bug Zappers": "Bug Zappers",
  "Building & Construction Toys": "Building & Construction Toys",
  "Bulletproof Protection": "Bulletproof Protection",
  "Bumpers": "Bumpers",
  "Business Backpack": "Business Backpack",
  "Business Garment Bag": "Business Garment Bag",
  "Business Shoes": "Business Shoes",
  "Business Supplies": "Business Supplies",
  "Bustiers & Corsets": "Bustiers & Corsets",
  "Cable Winder": "Cable Winder",
  "Cables Assemblies": "Cables Assemblies",
  "Cages & Accessories": "Cages & Accessories",
  "Camcorders": "Camcorders",
  "Camera & Photo": "Camera & Photo",
  "Camera Power": "Camera Power",
  "Camisoles & Tanks": "Camisoles & Tanks",
  "Camping": "Camping",
  "Camping Cookware": "Camping Cookware",
  "Camping Light": "Camping Light",
  "Camping Trolley": "Camping Trolley",
  "Candle Making": "Candle Making",
  "Candles & Holders": "Candles & Holders",
  "Canvas": "Canvas",
  "Canvas Shoulder Bag": "Canvas Shoulder Bag",
  "Canvas Waist Pack": "Canvas Waist Pack",
  "Car Body Films": "Car Body Films",
  "Car Body Repair Tools": "Car Body Repair Tools",
  "Car Covers": "Car Covers",
  "Car Disassembly Tools": "Car Disassembly Tools",
  "Car DVR": "Car DVR",
  "Car Electrical Appliances": "Car Electrical Appliances",
  "Car Electronic Accessories": "Car Electronic Accessories",
  "Car Electronics": "Car Electronics",
  "Car Headlight Assembly": "Car Headlight Assembly",
  "Car Headlight Bulbs": "Car Headlight Bulbs",
  "Car Intelligent Systems": "Car Intelligent Systems",
  "Car lacks & Lifting Equipment": "Car Jacks & Lifting Equipment",
  "Car Light Assemblies": "Car Light Assemblies",
  "Car Lights": "Car Lights",
  "Car Repair Tools": "Car Repair Tools",
  "Car Seat Covers": "Car Seat Covers",
  "Car Stickers": "Car Stickers",
  "Card Cutter": "Card Cutter",
  "Cardigan": "Cardigan",
  "Cardigans": "Cardigans",
  "Cardio Training": "Cardio Training",
  "Cargo Shirt": "Cargo Shirt",
  "Cargo Shorts": "Cargo Shorts",
  "Carriers": "Carriers",
  "Carriers & Strollers": "Carriers & Strollers",
  "Carry-Ons Luggage": "Carry-Ons Luggage",
  "Case": "Case",
  "Cashmere Wool Scarves": "Cashmere Wool Scarves",
  "Casual Business": "Casual Business",
  "Casual Pants": "Casual Pants",
  "Casual Shoes": "Casual Shoes",
  "Casual Sneaker": "Casual Sneaker",
  "Cat Doors, Steps, Nets & Pens": "Cat Doors, Steps, Nets & Pens",
  "Cats": "Cats",
  "CD Cases": "CD Cases",
  "CD Racks": "CD Racks",
  "Ceramics & Pottery": "Ceramics & Pottery",
  "Chain Bag": "Chain Bag",
  "Chain Bracelet": "Chain Bracelet",
  "Chain Waist Pack": "Chain Waist Pack",
  "Chains": "Chains",
  "Chair Leg Cove!": "Chair Leg Cove!",
  "Chaise Lounges": "Chaise Lounges",
  "Charger Cable": "Charger Cable",
  "Charms": "Charms",
  "Cheongsams": "Cheongsams",
  "Chest Bags": "Chest Bags",
  "Children's Bookcases": "Children's Bookcases",
  "Children's Flats": "Children's Flats",
  "Children's Shoes": "Children's Shoes",
  "Chinese Folk Dance": "Chinese Folk Dance",
  "Chinese Style": "Chinese Style",
  "Christmas Supplies": "Christmas Supplies",
  "Clamp Clip": "Clamp Clip",
  "Clamp Holder": "Clamp Holder",
  "Clamps": "Clamps",
  "Clarinet": "Clarinet",
  "Classical Dance Costume": "Classical Dance Costume",
  "Cleaning Appliances": "Cleaning Appliances",
  "Clearance Lights Assembly": "Clearance Lights Assembly",
  "Clip-In Extensions": "Clip-In Extensions",
  "Cloth Dryer": "Cloth Dryer",
  "Coffee Grinders": "Coffee Grinders",
  "Coffee Tables": "Coffee Tables",
  "Cold Room Systems": "Cold Room Systems",
  "Collars, Harnesses & Leashes": "Collars, Harnesses & Leashes",
  "Communications": "Communications",
  "Communications Antennas": "Communications Antennas",
  "Computer Components": "Computer Components",
  "Computer Desks": "Computer Desks",
  "Computer,Office & Education": "Computer, Office & Education",
  "Conference Tables": "Conference Tables",
  "Connectors": "Connectors",
  "Consumer Electronics": "Consumer Electronics",
  "Control Panties": "Control Panties",
  "Cooler Bag": "Cooler Bag",
  "Cooling Systems": "Cooling Systems",
  "Cosmetic Bag & Case": "Cosmetic Bag & Case",
  "Cosplay Costumes": "Cosplay Costumes",
  "Cotton Linen Shirt": "Cotton Linen Shirt",
  "Cotton Linen Shorts": "Cotton Linen Shorts",
  "Cover-Ups": "Cover-Ups",
  "Cow Mastitis Detectors": "Cow Mastitis Detectors",
  "Cradles": "Cradles",
  "Craft Toys": "Craft Toys",
  "Crates, Houses & Pens": "Crates, Houses & Pens",
  "Credit Card Holder": "Credit Card Holder",
  "Crochet Hair": "Crochet Hair",
  "Crossbody Bags": "Crossbody Bags",
  "Cultural Clothing": "Cultural Clothing",
  "Cups": "Cups",
  "Curly Wigs": "Curly Wigs",
  "Curve & Plus Size": "Curve & Plus Size",
  "Cushions": "Cushions",
  "Cycling": "Cycling",
  "Cycling Bib Short": "Cycling Bib Short",
  "Cycling Sunglasses": "Cycling Sunglasses",
  "Cycling Vest": "Cycling Vest",
  "Dancewear": "Dancewear",
  "Decorative Mirrors": "Decorative Mirrors",
  "Deep Wave Wigs": "Deep Wave Wigs",
  "Dehumidifier": "Dehumidifier",
  "Demon Slayer": "Demon Slayer",
  "Denim lacket": "Denim Jacket",
  "Denim Shirt": "Denim Shirt",
  "Denim Shorts": "Denim Shorts",
  "Denim Shoulder Bag": "Denim Shoulder Bag",
  "Densitometers": "Densitometers",
  "Dental Chair Cover": "Dental Chair Cover",
  "Dental consumable": "Dental Consumable",
  "Dental Drills & Brush": "Dental Drills & Brush",
  "Dental Grill": "Dental Grill",
  "Dental Supplies": "Dental Supplies",
  "Dentist Seat": "Dentist Seat",
  "Derby Shoes": "Derby Shoes",
  "Desktops": "Desktops",
  "Desktops & AIO": "Desktops & All-in-One",
  "Diagnostic Tools": "Diagnostic Tools",
  "Diamond Painting": "Diamond Painting",
  "Diaper Bags": "Diaper Bags",
  "Dice": "Dice",
  "Diffuser Aromatherapy": "Diffuser Aromatherapy",
  "Digital Cameras": "Digital Cameras",
  "Digital Watches": "Digital Watches",
  "Dining Chairs": "Dining Chairs",
  "Dining Room": "Dining Room",
  "Dining Room Furniture": "Dining Room Furniture",
  "Dining Room Sets": "Dining Room Sets",
  "Dining Tables": "Dining Tables",
  "DIY Bags": "DIY Bags",
  "DlY Accessories": "DIY Accessories",
  "DlY Gaming Computer": "DIY Gaming Computer",
  "Dogs": "Dogs",
  "Doll Houses": "Doll Houses",
  "Dolls": "Dolls",
  "Dolls & Accessories": "Dolls & Accessories",
  "Dolls Accessories": "Dolls Accessories",
  "Domino": "Domino",
  "Door Remote Controls": "Door Remote Controls",
  "Door Screen": "Door Screen",
  "Doorbell": "Doorbell",
  "Double Breasted Suits": "Double Breasted Suits",
  "Down Coats": "Down Coats",
  "Down Jackets": "Down Jackets",
  "Drawing": "Drawing",
  "Drawing Tablet": "Drawing Tablet",
  "Drawing Toys": "Drawing Toys",
  "Drawstring Bag": "Drawstring Bag",
  "Dress Sets": "Dress Sets",
  "Dresses": "Dresses",
  "Drop & Dangle Earring": "Drop & Dangle Earring",
  "Dropper": "Dropper",
  "Drum": "Drum",
  "Dumbbells": "Dumbbells",
  "Duvets": "Duvets",
  "Ear Piercing": "Ear Piercing",
  "Ear Protection": "Ear Protection",
  "Ear Tags": "Ear Tags",
  "Earbuds": "Earbuds",
  "earbuds": "Earbuds",
  "Earring Set": "Earring Set",
  "Earrings": "Earrings",
  "Eas Kits": "Eas Kits",
  "Easel": "Easel",
  "Electric Beverage Warmer": "Electric Beverage Warmer",
  "Electric Cleaning Brush": "Electric Cleaning Brush",
  "Electric Espresso Pots": "Electric Espresso Pots",
  "Electric Fireplace": "Electric Fireplace",
  "Electric Floor Mop": "Electric Floor Mop",
  "Electric Heater": "Electric Heater",
  "Electric Scooter": "Electric Scooter",
  "Electric Screwdriver": "Electric Screwdriver",
  "Electric Sweeper": "Electric Sweeper",
  "Electric Toothbrushes": "Electric Toothbrushes",
  "Electric Water Heaters": "Electric Water Heaters",
  "Electric Wrench": "Electric Wrench",
  "Electrical & lgnitions": "Electrical & Ignitions",
  "Electrical Equipment & Supplies": "Electrical Equipment & Supplies",
  "Electronic Blocks": "Electronic Blocks",
  "Electronic Mosquito Killer": "Electronic Mosquito Killer",
  "Electronic Pets": "Electronic Pets",
  "Electronic Toys": "Electronic Toys",
  "Electronic Watches": "Electronic Watches",
  "Emergency Kits & Defense": "Emergency Kits & Defense",
  "End Tables": "End Tables",
  "Endoscope Camera": "Endoscope Camera",
  "Engine Oil": "Engine Oil",
  "Engine Parts": "Engine Parts",
  "Engines & Components": "Engines & Components",
  "Engines & Engine Parts": "Engines & Engine Parts",
  "Entertainment": "Entertainment",
  "European Clothing": "European Clothing",
  "EVA Slippers": "EVA Slippers",
  "Eve Massage Instrument": "Eve Massage Instrument",
  "Exercise Wheels": "Exercise Wheels",
  "Exhaust Fan": "Exhaust Fan",
  "Exhaust Systems": "Exhaust Systems",
  "Exotic Pants": "Exotic Pants",
  "Exterior Accessories": "Exterior Accessories",
  "Eyeglass Lenses": "Eyeglass Lenses",
  "Fabric & Lace": "Fabric & Lace",
  "Face Recognition Locks": "Face Recognition Locks",
  "Family Intelligence System": "Family Intelligence System",
  "Fantasy Figurine": "Fantasy Figurine",
  "Farm Animals": "Farm Animals",
  "Fascia Gun": "Fascia Gun",
  "Fashion Belts": "Fashion Belts",
  "Fashion Quartz Wristwatches": "Fashion Quartz Wristwatches",
  "Fashion Suits": "Fashion Suits",
  "Fashionable Canes": "Fashionable Canes",
  "Fasteners": "Fasteners",
  "Faucet Replacement Parts": "Faucet Replacement Parts",
  "Feeding": "Feeding",
  "Feeding & Watering Supplies": "Feeding & Watering Supplies",
  "Festive & Party Supplies": "Festive & Party Supplies",
  "Fiber Optic Equipment": "Fiber Optic Equipment",
  "Filing & Binding Products": "Filing & Binding Products",
  "Filing Cabinets": "Filing Cabinets",
  "Films & Instant Photo Paper": "Films & Instant Photo Paper",
  "Fingerprint Locks": "Fingerprint Locks",
  "Fireplaces & Stoves": "Fireplaces & Stoves",
  "First Aid Kits": "First Aid Kits",
  "Fish & Aquatic Pets": "Fish & Aquatic Pets",
  "Fish Finders": "Fish Finders",
  "Fish Toe": "Fish Toe",
  "Fishing": "Fishing",
  "Fishing Bags": "Fishing Bags",
  "Fishing Floats": "Fishing Floats",
  "Fishing Jerseys": "Fishing Jerseys",
  "Fishing Tools": "Fishing Tools",
  "Fitness Pedals": "Fitness Pedals",
  "Flamenco": "Flamenco",
  "Flashlight": "Flashlight",
  "Flat Sandals": "Flat Sandals",
  "Flats": "Flats",
  "Flea & Tick Controls": "Flea & Tick Controls",
  "Flip Flops": "Flip Flops",
  "Floor Heating Systems": "Floor Heating Systems",
  "Floor Socks": "Floor Socks",
  "Flute": "Flute",
  "Fomer": "Foamer",
  "Food Service": "Food Service",
  "Formal Occasion Dresses": "Formal Occasion Dresses",
  "Four Wheel Electric Car": "Four Wheel Electric Car",
  "Fresh Air Ventilator": "Fresh Air Ventilator",
  "Fuel Supply Systems": "Fuel Supply Systems",
  "Fun Hats": "Fun Hats",
  "Fun Sunglasses": "Fun Sunglasses",
  "Funiture": "Furniture",
  "Funny Masks": "Funny Masks",
  "Fur Shoulder Bag": "Fur Shoulder Bag",
  "G-String": "G-String",
  "Game Collection Cards": "Game Collection Cards",
  "Game Deals": "Game Deals",
  "Games & Accessories": "Games & Accessories",
  "Gaming Hardware": "Gaming Hardware",
  "Gaming Keyboard": "Gaming Keyboard",
  "Gaming Motherboard": "Gaming Motherboard",
  "Gaming Mouse": "Gaming Mouse",
  "Gaming PC Case": "Gaming PC Case",
  "Garden & Balcony": "Garden & Balcony",
  "Garden Buildings": "Garden Buildings",
  "Garden Furniture Sets": "Garden Furniture Sets",
  "Garden Pots & Planters": "Garden Pots & Planters",
  "Garden Shredder": "Garden Shredder",
  "Garden Water Timers": "Garden Water Timers",
  "Gardening Supplies": "Gardening Supplies",
  "Gardening Tools": "Gardening Tools",
  "Garment Steamer": "Garment Steamer",
  "Gems": "Gems",
  "Genshin lmpact": "Genshin Impact",
  "Genuine Leather Sandals": "Genuine Leather Sandals",
  "Gift & Gift Bag": "Gift & Gift Bag",
  "Glasses": "Glasses",
  "Gloves & Handwear": "Gloves & Handwear",
  "Glow Supplies": "Glow Supplies",
  "GPS & Accessories": "GPS & Accessories",
  "GPS Accessories": "GPS Accessories",
  "GPS Tracker": "GPS Tracker",
  "Graphics Cards": "Graphics Cards",
  "Grooming": "Grooming",
  "Guitar": "Guitar",
  "Gym Shorts": "Gym Shorts",
  "Gyms & Playmats": "Gyms & Playmats",
  "Habitat Decors": "Habitat Decors",
  "Habitat Lights": "Habitat Lights",
  "Hair Bundles with Closures": "Hair Bundles with Closures",
  "Hair Care": "Hair Care",
  "Hair Dryer": "Hair Dryer",
  "Hair Dryers": "Hair Dryers",
  "Hair Elastics & Ties": "Hair Elastics & Ties",
  "Hair Extensions": "Hair Extensions",
  "Hair Extensions & Wigs": "Hair Extensions & Wigs",
  "Hair jewelry": "Hair Jewelry",
  "Hair Pieces": "Hair Pieces",
  "Hair Tools & Accessories": "Hair Tools & Accessories",
  "Hair Toppers For Women": "Hair Toppers For Women",
  "Hair Towel": "Hair Towel",
  "Hair Weaving": "Hair Weaving",
  "Hairnets": "Hairnets",
  "Hammocks": "Hammocks",
  "Hand Dryer": "Hand Dryer",
  "Hand Grips": "Hand Grips",
  "Hand Protection": "Hand Protection",
  "Hand Tools": "Hand Tools",
  "Hand Towel": "Hand Towel",
  "Hand Washer": "Hand Washer",
  "Handbags": "Handbags",
  "Handheld Game Players": "Handheld Game Players",
  "Handkerchief Towels": "Handkerchief Towels",
  "Handkerchiefs": "Handkerchiefs",
  "Hanfu": "Hanfu",
  "Hard Baits": "Hard Baits",
  "Hardware": "Hardware",
  "Hats": "Hats",
  "Hats, Scarves & Gloves": "Hats, Scarves & Gloves",
  "Headband Wigs": "Headband Wigs",
  "Headbands": "Headbands",
  "Headboards": "Headboards",
  "Headwear": "Headwear",
  "Heating & Cooling": "Heating & Cooling",
  "Heating,Venting & Cooling": "Heating, Venting & Cooling",
  "Heeled Sandals": "Heeled Sandals",
  "Helmets": "Helmets",
  "Hidden Heel": "Hidden Heel",
  "High Boots": "High Boots",
  "High Density Lace Wigs": "High Density Lace Wigs",
  "High-Capactiy Backpack": "High-Capacity Backpack",
  "Highchairs": "Highchairs",
  "Hiking": "Hiking",
  "Hiking Scarves": "Hiking Scarves",
  "Hiking Shoes": "Hiking Shoes",
  "Hiking Vests": "Hiking Vests",
  "Hippop Necklace": "Hip Hop Necklace",
  "Hobby & Collectibles": "Hobby & Collectibles",
  "Hobo Bags": "Hobo Bags",
  "Holders & Stands": "Holders & Stands",
  "Home & Garden": "Home & Garden",
  "Home Appliances": "Home Appliances",
  "Home Brewing & Wine Making Barware": "Home Brewing & Wine Making Barware",
  "Home Fragrance": "Home Fragrance",
  "Home Improvenment & Lighting": "Home Improvement & Lighting",
  "Home Office": "Home Office",
  "Home Safes & Safe Accessories": "Home Safes & Safe Accessories",
  "Homecoming Dresses": "Homecoming Dresses",
  "Hooded Down jacket": "Hooded Down Jacket",
  "Hooks": "Hooks",
  "Hoop Earring": "Hoop Earring",
  "Horizontal Bars": "Horizontal Bars",
  "Hotel Uniforms": "Hotel Uniforms",
  "Household Appliances": "Household Appliances",
  "Houses & Habitats": "Houses & Habitats",
  "Human Hair 360 Lace": "Human Hair 360 Lace",
  "Human Hair Extensions": "Human Hair Extensions",
  "Human Hair Full Lace": "Human Hair Full Lace",
  "Human Hair Ponytails": "Human Hair Ponytails",
  "Human Hair T-Part": "Human Hair T-Part",
  "Humidifier": "Humidifier",
  "Hvac Systems & Parts": "HVAC Systems & Parts",
  "Indoor Cycling Bikes": "Indoor Cycling Bikes",
  "Induction Cookers": "Induction Cookers",
  "Inflatable Toys": "Inflatable Toys",
  "Infrared Alarm Detector": "Infrared Alarm Detector",
  "Ink Bottle": "Ink Bottle",
  "Ink Supplies": "Ink Supplies",
  "Insoles": "Insoles",
  "Inspection Tools": "Inspection Tools",
  "Instruments & Gauges": "Instruments & Gauges",
  "Intercom": "Intercom",
  "Interior Accessories": "Interior Accessories",
  "Invisible Bras": "Invisible Bras",
  "iPhone": "iPhone",
  "Jackets": "Jackets",
  "jackets": "Jackets",
  "Jeams": "Jeans",
  "Jeans": "Jeans",
  "Jewelry & Watches": "Jewelry & Watches",
  "Jewelry Findings": "Jewelry Findings",
  "Jewelry Making": "Jewelry Making",
  "Jewelry Packagings": "Jewelry Packaging",
  "Jewelry Sets": "Jewelry Sets",
  "Jewish Wigs": "Jewish Wigs",
  "JK Socks": "JK Socks",
  "Jumbo Braids": "Jumbo Braids",
  "Jump Starters": "Jump Starters",
  "Jumpsuits": "Jumpsuits",
  "K Gold": "K Gold",
  "K Gold Bracelet": "K Gold Bracelet",
  "K Gold Earring": "K Gold Earring",
  "Kalimba": "Kalimba",
  "Kebaya": "Kebaya",
  "Key Box": "Key Box",
  "Key Chains": "Key Chains",
  "Kid's Accessories": "Kid's Accessories",
  "Kid's Clothing": "Kid's Clothing",
  "Kid's Luggage": "Kid's Luggage",
  "Kids Canvas Shoe": "Kids Canvas Shoe",
  "Kids Gifts": "Kids Gifts",
  "Kids' Balance Bikes": "Kids' Balance Bikes",
  "Kids' Frames": "Kids' Frames",
  "Kids' Hair Accessories": "Kids' Hair Accessories",
  "Kids' Sun Hats": "Kids' Sun Hats",
  "Kids' sunglasses": "Kids' Sunglasses",
  "Kids' Swing Car": "Kids' Swing Car",
  "Kitchen": "Kitchen",
  "Kitchen Appliances": "Kitchen Appliances",
  "Kitchen Cabinet Storage": "Kitchen Cabinet Storage",
  "Kitchen Faucets": "Kitchen Faucets",
  "Kitchen Fixtures": "Kitchen Fixtures",
  "Kitchen Hardware": "Kitchen Hardware",
  "Kitchen Sinks": "Kitchen Sinks",
  "Kitchen Soap Dispensers": "Kitchen Soap Dispensers",
  "Knitted Dresses": "Knitted Dresses",
  "Knitted Gloves": "Knitted Gloves",
  "Knitwears": "Knitwears",
  "Lab Supplies": "Lab Supplies",
  "Lace Braided Wigs": "Lace Braided Wigs",
  "Lace Wigs": "Lace Wigs",
  "lar": "Lar",
  "Large Size Luggage": "Large Size Luggage",
  "Laser Cutting Machine": "Laser Cutting Machine",
  "Laser Engraving Machine": "Laser Engraving Machine",
  "Laser Levels": "Laser Levels",
  "Laundry Appliances": "Laundry Appliances",
  "Layered Necklace": "Layered Necklace",
  "lce Crushers": "Ice Crushers",
  "lce Shorts": "Ice Shorts",
  "Leakage Detector": "Leakage Detector",
  "Learning & Education": "Learning & Education",
  "Leather Boots": "Leather Boots",
  "Leather Casual": "Leather Casual",
  "Leather Coat": "Leather Coat",
  "Leather Pants": "Leather Pants",
  "Leather Shoes": "Leather Shoes",
  "Leather Waist Pack": "Leather Waist Pack",
  "Leggings": "Leggings",
  "lgnition Systems": "Ignition Systems",
  "License Plate Recognition Camera": "License Plate Recognition Camera",
  "Light Bulbs": "Light Bulbs",
  "Lighting Bulbs & Tubes": "Lighting Bulbs & Tubes",
  "Lightweight Down Jacket": "Lightweight Down Jacket",
  "Linear Guides": "Linear Guides",
  "Lingerie & Loungewear": "Lingerie & Loungewear",
  "Links, Rings & Tubes": "Links, Rings & Tubes",
  "Lint Remover": "Lint Remover",
  "Liquid Chalk": "Liquid Chalk",
  "Litter & Housebreaking": "Litter & Housebreaking",
  "Living Room": "Living Room",
  "Living Room Cabinets": "Living Room Cabinets",
  "Living Room Chairs": "Living Room Chairs",
  "Living Room Furniture": "Living Room Furniture",
  "Living Room Sofas": "Living Room Sofas",
  "Loafers": "Loafers",
  "Lolita": "Lolita",
  "Long Down Coats": "Long Down Coats",
  "Long Down Jacket": "Long Down Jacket",
  "Long Dresses": "Long Dresses",
  "Long Sleeve Dresses": "Long Sleeve Dresses",
  "Long Sleeve Tees": "Long Sleeve Tees",
  "Low Cut Socks": "Low Cut Socks",
  "lron": "Iron",
  "Luggage Covers": "Luggage Covers",
  "Luggage Tags": "Luggage Tags",
  "Luggages & Bags": "Luggages & Bags",
  "Lunch Bag": "Lunch Bag",
  "Machine & Accessories": "Machine & Accessories",
  "Machine Tool Spindle": "Machine Tool Spindle",
  "Magic Cubes": "Magic Cubes",
  "Magic Tricks": "Magic Tricks",
  "Magnetic Materials": "Magnetic Materials",
  "Make Up": "Make Up",
  "Make up": "Make Up",
  "make up tools": "Makeup Tools",
  "Marble Runs": "Marble Runs",
  "Martin Boots": "Martin Boots",
  "Mary Janes": "Mary Janes",
  "Massage & Relaxation": "Massage & Relaxation",
  "Massage Roller": "Massage Roller",
  "Mat": "Mat",
  "Matching Sets": "Matching Sets",
  "Material": "Material",
  "Material Paper": "Material Paper",
  "Math Toys": "Math Toys",
  "Mattress Cover": "Mattress Cover",
  "Mattresses": "Mattresses",
  "Measurement & Analysis Tools": "Measurement & Analysis Tools",
  "Mechanical Watches": "Mechanical Watches",
  "Medical Uniforms": "Medical Uniforms",
  "Memorials & Funerary": "Memorials & Funerary",
  "Men's Bags": "Men's Bags",
  "Men's Belts": "Men's Belts",
  "Men's Boots": "Men's Boots",
  "Men's Causal Shoes": "Men's Casual Shoes",
  "Men's Clothing": "Men's Clothing",
  "Men's Fold Wallet": "Men's Fold Wallet",
  "Men's Leather Wallet": "Men's Leather Wallet",
  "Men's Necklace": "Men's Necklace",
  "Men's Sandals & Slippers": "Men's Sandals & Slippers",
  "Men's Underwear": "Men's Underwear",
  "Men's Wallet with Zipper": "Men's Wallet with Zipper",
  "Men's Watches": "Men's Watches",
  "Menstrual Panties": "Menstrual Panties",
  "Messenger Bag": "Messenger Bag",
  "Microscopes": "Microscopes",
  "Middle Heel": "Middle Heel",
  "Middle Size Luggage": "Middle Size Luggage",
  "Midi Dresses": "Midi Dresses",
  "Military Boots": "Military Boots",
  "Minimizer Bras": "Minimizer Bras",
  "Mobile Phone Antennas": "Mobile Phone Antennas",
  "Mobile Phone Batteries": "Mobile Phone Batteries",
  "Mobile Phone Cables": "Mobile Phone Cables",
  "Mobile Phone Chargers": "Mobile Phone Chargers",
  "Mobile Phone Flex Cables": "Mobile Phone Flex Cables",
  "Mobile Phone Housings & Frames": "Mobile Phone Housings & Frames",
  "Mobile Phone lcD Screens": "Mobile Phone LCD Screens",
  "Mobile Phones": "Mobile Phones",
  "Moissanite Bracelet": "Moissanite Bracelet",
  "Money & Banking ToyS": "Money & Banking Toys",
  "Mosquito Nets": "Mosquito Nets",
  "Mossinate": "Mossinate",
  "Mother Shoes": "Mother Shoes",
  "Motherboards": "Motherboards",
  "Motorcycle & ATV": "Motorcycle & ATV",
  "Motorcycle Gear": "Motorcycle Gear",
  "Motorcycle ltems": "Motorcycle Items",
  "Motorcycle Pants": "Motorcycle Pants",
  "Motorcycle Parts": "Motorcycle Parts",
  "Motorcycles": "Motorcycles",
  "MP3/MP4 Bags & Cases": "MP3/MP4 Bags & Cases",
  "Mug Thermos": "Mug Thermos",
  "Mules Sandals": "Mules Sandals",
  "Multi-Purpose Bag": "Multi-Purpose Bag",
  "Musical Instruments": "Musical Instruments",
  "Mystery Box": "Mystery Box",
  "Natural Stone Bracelet": "Natural Stone Bracelet",
  "Neck Fan": "Neck Fan",
  "Neck Massage Instrument": "Neck Massage Instrument",
  "Necklaces": "Necklaces",
  "Needle": "Needle",
  "Needle Arts & Craft": "Needle Arts & Craft",
  "New in": "New in",
  "New in Backpack": "New in Backpack",
  "New in Bracelets": "New in Bracelets",
  "New in Coats & Jackets": "New in Coats & Jackets",
  "New in Dresses": "New in Dresses",
  "New in Findings": "New in Findings",
  "New in Handbag": "New in Handbag",
  "New in Hoodies & Sweatshirts": "New in Hoodies & Sweatshirts",
  "New in Keychains": "New in Keychains",
  "New in Knitwears": "New in Knitwears",
  "New in Matching Sets": "New in Matching Sets",
  "New in Men's Sets": "New in Men's Sets",
  "New in Men's Sleepwear": "New in Men's Sleepwear",
  "New in Men's Socks": "New in Men's Socks",
  "New in Men's Underwear": "New in Men's Underwear",
  "New in Men's Watches": "New in Men's Watches",
  "New in Necklaces": "New in Necklaces",
  "New in Outerwears": "New in Outerwears",
  "New in Pants": "New in Pants",
  "New in Pants & Capris": "New in Pants & Capris",
  "New in Rings": "New in Rings",
  "New in Shorts": "New in Shorts",
  "New in Suits & Blazers": "New in Suits & Blazers",
  "New in Tops & Tees": "New in Tops & Tees",
  "New in Women's Boots": "New in Women's Boots",
  "New in Women's Sleepwear": "New in Women's Sleepwear",
  "New in Women's Socks": "New in Women's Socks",
  "New in Women's Underwear": "New in Women's Underwear",
  "Nightgowns": "Nightgowns",
  "Nightstands": "Nightstands",
  "Nose Nail": "Nose Nail",
  "Notebooks & Papers": "Notebooks & Papers",
  "Nursery & Baby Furniture": "Nursery & Baby Furniture",
  "O-Neck Pullovers": "O-Neck Pullovers",
  "Office Chairs": "Office Chairs",
  "Office Furniture": "Office Furniture",
  "One Piece Hats": "One Piece Hats",
  "One Pieces": "One Pieces",
  "Open Closets": "Open Closets",
  "Other Apparel Accessories": "Other Apparel Accessories",
  "Other Bags & Accessories": "Other Bags & Accessories",
  "Other Jewalry": "Other Jewelry",
  "Other Kid's Bags": "Other Kid's Bags",
  "Outdoor Backpack": "Outdoor Backpack",
  "Outdoor Bags": "Outdoor Bags",
  "Outdoor Belts": "Outdoor Belts",
  "Outdoor cooler": "Outdoor Cooler",
  "Outdoor Drainage": "Outdoor Drainage",
  "Outdoor Furniture": "Outdoor Furniture",
  "Outdoor Heaters": "Outdoor Heaters",
  "Outdoor Sandals": "Outdoor Sandals",
  "Outerwear": "Outerwear",
  "Outerwears": "Outerwears",
  "Over Knee": "Over Knee",
  "Oxfords": "Oxfords",
  "Pacifiers": "Pacifiers",
  "Packing": "Packing",
  "Packing Box": "Packing Box",
  "Padlocks": "Padlocks",
  "Painting By Numbers": "Painting By Numbers",
  "Painting Canva": "Painting Canvas",
  "Painting Supplies & Wall Treatments": "Painting Supplies & Wall Treatments",
  "Pajama Sets": "Pajama Sets",
  "Palette": "Palette",
  "Panoramic Camera": "Panoramic Camera",
  "Pant Sets": "Pant Sets",
  "Panties": "Panties",
  "Pants": "Pants",
  "Paper": "Paper",
  "Paper Holder": "Paper Holder",
  "Paracord": "Paracord",
  "Parkas": "Parkas",
  "Parking Lock": "Parking Lock",
  "Part Lace Wigs": "Part Lace Wigs",
  "Party Dresses": "Party Dresses",
  "Party Games": "Party Games",
  "Party Supplies": "Party Supplies",
  "Party Wigs": "Party Wigs",
  "Patio Umbrellas & Bases": "Patio Umbrellas & Bases",
  "PC Power Supplies": "PC Power Supplies",
  "Pearl": "Pearl",
  "Pearl Necklace": "Pearl Necklace",
  "Peephole": "Peephole",
  "Pen Cap": "Pen Cap",
  "Pen Head": "Pen Head",
  "Pencil Case": "Pencil Case",
  "Pencil Pants": "Pencil Pants",
  "Pencil Pot": "Pencil Pot",
  "Personal Care Appliances": "Personal Care Appliances",
  "Pet Supplies": "Pet Supplies",
  "Phone Cases": "Phone Cases",
  "Phone Repair Tools": "Phone Repair Tools",
  "Phones & Telecommunications": "Phones & Telecommunications",
  "Phones Accessories": "Phones Accessories",
  "Phones Parts": "Phones Parts",
  "Photo Albums": "Photo Albums",
  "Photo Studio Kits": "Photo Studio Kits",
  "Picture Card": "Picture Card",
  "Piexi Cut Wigs": "Pixie Cut Wigs",
  "Pigment": "Pigment",
  "Pillow Shoulder Bag": "Pillow Shoulder Bag",
  "Plaid Scarves": "Plaid Scarves",
  "Plain Shirt": "Plain Shirt",
  "Play Mats": "Play Mats",
  "Playing Cards": "Playing Cards",
  "Plumbing": "Plumbing",
  "Plumbing Hoses": "Plumbing Hoses",
  "Plus Size Down Coats": "Plus Size Down Coats",
  "Plus Size Dresses": "Plus Size Dresses",
  "Plus Size Matching Sets": "Plus Size Matching Sets",
  "Plus Size Outwears": "Plus Size Outerwears",
  "Plus Size Panties": "Plus Size Panties",
  "Plus Size Swimwears": "Plus Size Swimwears",
  "Plus Size Tops": "Plus Size Tops",
  "Plus Size Wedding Dress": "Plus Size Wedding Dress",
  "Pneumatic Parts": "Pneumatic Parts",
  "Pointed Toe": "Pointed Toe",
  "Polarized Sunglasses": "Polarized Sunglasses",
  "Polisher": "Polisher",
  "Polo Shirts": "Polo Shirts",
  "Pools & Water Activities": "Pools & Water Activities",
  "Portable Television": "Portable Television",
  "Portable Washing Machine": "Portable Washing Machine",
  "Portfolio": "Portfolio",
  "Postcard": "Postcard",
  "Poster": "Poster",
  "Power Banks": "Power Banks",
  "Power Filters": "Power Filters",
  "Power Supplies": "Power Supplies",
  "Power Transmission Parts": "Power Transmission Parts",
  "Pre-Order": "Pre-Order",
  "Prescription Glasses": "Prescription Glasses",
  "Pressure Cookers": "Pressure Cookers",
  "Priest Uniforms": "Priest Uniforms",
  "Print Sweater": "Print Sweater",
  "Print Waist Pack": "Print Waist Pack",
  "Printed Shirt": "Printed Shirt",
  "Programmable Toys": "Programmable Toys",
  "Prom Dresses": "Prom Dresses",
  "Pullovers": "Pullovers",
  "Pump Accessories": "Pump Accessories",
  "Pumps": "Pumps",
  "Puzzles": "Puzzles",
  "Quartz Watches": "Quartz Watches",
  "Quick Dry Towel": "Quick Dry Towel",
  "Quilts": "Quilts",
  "Quinceanera Dresses": "Quinceanera Dresses",
  "Racing Boats & Kayaking": "Racing Boats & Kayaking",
  "Racing Drones": "Racing Drones",
  "Racquet Sports": "Racquet Sports",
  "Rail Systems": "Rail Systems",
  "Rain Boots": "Rain Boots",
  "RC Airplanes": "RC Airplanes",
  "RC Boats": "RC Boats",
  "RC Motorcycles": "RC Motorcycles",
  "RC Stunt Cars": "RC Stunt Cars",
  "RC Trains": "RC Trains",
  "Rear Bumper Lights Assembly": "Rear Bumper Lights Assembly",
  "Reborn Dolls": "Reborn Dolls",
  "Relaxation Treatment": "Relaxation Treatment",
  "Remote Control Toys": "Remote Control Toys",
  "Replacement Parts": "Replacement Parts",
  "Reptiles & Amphibians": "Reptiles & Amphibians",
  "Resin DlY": "Resin DIY",
  "Resistance Bands": "Resistance Bands",
  "Respirator": "Respirator",
  "Restaurant Tables": "Restaurant Tables",
  "Ring Clip": "Ring Clip",
  "Ripped Jeans": "Ripped Jeans",
  "Rom Strap Shoes": "Rom Strap Shoes",
  "Round Toe": "Round Toe",
  "Rugged Smartphones": "Rugged Smartphones",
  "Safes": "Safes",
  "Safety Short Pants": "Safety Short Pants",
  "Sandals": "Sandals",
  "Sander": "Sander",
  "Sashes": "Sashes",
  "Scarves & Gloves": "Scarves & Gloves",
  "School Supplies": "School Supplies",
  "Scouting Uniforms": "Scouting Uniforms",
  "Screen Protectors": "Screen Protectors",
  "Sculptures & Figurine": "Sculptures & Figurine",
  "Sculptures & Figurines": "Sculptures & Figurines",
  "Seamless Bras": "Seamless Bras",
  "Security & Protection": "Security & Protection",
  "Self Defense": "Self Defense",
  "Sets": "Sets",
  "Sexy Panties": "Sexy Panties",
  "Shapers": "Shapers",
  "Sharpener": "Sharpener",
  "Sheet Sets": "Sheet Sets",
  "Shelter": "Shelter",
  "Shirt jacket": "Shirt Jacket",
  "Shirts": "Shirts",
  "Shirts & Blouses": "Shirts & Blouses",
  "Shock Absorbers": "Shock Absorbers",
  "Shoe Accessories": "Shoe Accessories",
  "Shoe Care Kit": "Shoe Care Kit",
  "Shoe Decorations": "Shoe Decorations",
  "Shoe Dryer": "Shoe Dryer",
  "Shoe Polishes": "Shoe Polishes",
  "Shoelaces": "Shoelaces",
  "Shoes": "Shoes",
  "Shoes Covers": "Shoes Covers",
  "Shopping Bag": "Shopping Bag",
  "Short Down Coats": "Short Down Coats",
  "Short Down lacket": "Short Down Jacket",
  "Short Dresses": "Short Dresses",
  "Short Sets": "Short Sets",
  "Shorts": "Shorts",
  "Shoulder Bags": "Shoulder Bags",
  "Shower System": "Shower System",
  "Signal Lamp Assemblies": "Signal Lamp Assemblies",
  "Silk Base Lace Wigs": "Silk Base Lace Wigs",
  "Silk Scarves": "Silk Scarves",
  "Silk Scarves & Ribbons": "Silk Scarves & Ribbons",
  "Silver 925": "Silver 925",
  "Silver Bracelet": "Silver Bracelet",
  "Silver Earring": "Silver Earring",
  "Silver Necklace": "Silver Necklace",
  "Single Breasted Suits": "Single Breasted Suits",
  "Sit Up Benches": "Sit Up Benches",
  "Skateboard": "Skateboard",
  "Sketch": "Sketch",
  "Skirts": "Skirts",
  "Sleep & Lounge": "Sleep & Lounge",
  "Sleeping Bags": "Sleeping Bags",
  "Sleepwear": "Sleepwear",
  "Slim leans": "Slim Jeans",
  "Small Animals": "Small Animals",
  "Smart Bathroom": "Smart Bathroom",
  "Smart Curtains": "Smart Curtains",
  "Smart Dimmers": "Smart Dimmers",
  "Smart Electronics": "Smart Electronics",
  "Smart Home": "Smart Home",
  "Smart Remote Controls": "Smart Remote Controls",
  "Smart Smoke Detectors": "Smart Smoke Detectors",
  "Smart Switches": "Smart Switches",
  "Smart Thermostats": "Smart Thermostats",
  "Smart Watches": "Smart Watches",
  "Smart Water Heaters": "Smart Water Heaters",
  "Smartphone 5g": "Smartphone 5G",
  "Smartphone Android": "Smartphone Android",
  "Sneaker": "Sneaker",
  "Snooker & Billiard Accessories": "Snooker & Billiard Accessories",
  "Snow Boots": "Snow Boots",
  "Snowmobile Gears": "Snowmobile Gears",
  "Soccer Tables": "Soccer Tables",
  "Socks": "Socks",
  "Socks & Leg Warmers": "Socks & Leg Warmers",
  "Soft Plastic Blocks": "Soft Plastic Blocks",
  "Solar Inverters": "Solar Inverters",
  "Solar Panels": "Solar Panels",
  "Solar Water Heaters": "Solar Water Heaters",
  "Solid Color Scarves": "Solid Color Scarves",
  "Sound Cards": "Sound Cards",
  "Special Occasion Costume": "Special Occasion Costume",
  "Special Occasion Dresses": "Special Occasion Dresses",
  "Spectrum Analyzers": "Spectrum Analyzers",
  "Spinning Top": "Spinning Top",
  "Sport Hoops": "Sport Hoops",
  "Sport Waist Pack": "Sport Waist Pack",
  "Sports & Entertainment": "Sports & Entertainment",
  "Sports & Outdoor Activities": "Sports & Outdoor Activities",
  "Sports Suits": "Sports Suits",
  "Sports Video Cameras": "Sports Video Cameras",
  "Sports Video Cameras Accessories": "Sports Video Cameras Accessories",
  "Spray Gun": "Spray Gun",
  "Spy Family": "Spy Family",
  "Square Bag": "Square Bag",
  "Stamp": "Stamp",
  "Stamps Toys": "Stamps Toys",
  "Stand Fan": "Stand Fan",
  "Stapler": "Stapler",
  "Stationary": "Stationery",
  "Steam Cleaner": "Steam Cleaner",
  "Steering Covers": "Steering Covers",
  "Steppers": "Steppers",
  "Sticker Book": "Sticker Book",
  "Stickers": "Stickers",
  "Stickers & Poster": "Stickers & Poster",
  "Sticky Notes": "Sticky Notes",
  "Stockings": "Stockings",
  "Stowing Tidying": "Stowing & Tidying",
  "Straight Pants": "Straight Pants",
  "Strapless Bras": "Strapless Bras",
  "Street Dance": "Street Dance",
  "Strength Training": "Strength Training",
  "Striped Sweater": "Striped Sweater",
  "Suit jackets": "Suit Jackets",
  "Suit Pants": "Suit Pants",
  "Suits": "Suits",
  "Sun Hats": "Sun Hats",
  "Sun Loungers": "Sun Loungers",
  "Sunglasses": "Sunglasses",
  "Sunshades": "Sunshades",
  "Super-High Heel": "Super-High Heel",
  "Surfboard & Paddleboards": "Surfboard & Paddleboards",
  "Surfing & Beach Shorts": "Surfing & Beach Shorts",
  "Surfing & Kayaking": "Surfing & Kayaking",
  "Surfing Accessories": "Surfing Accessories",
  "Sweater Matching Sets": "Sweater Matching Sets",
  "Sweater Vest": "Sweater Vest",
  "Sweaters": "Sweaters",
  "Sweatpants": "Sweatpants",
  "Swimming Pools": "Swimming Pools",
  "Swimswears": "Swimwears",
  "Synthetic Chignon": "Synthetic Chignon",
  "Synthetic Hair Lace": "Synthetic Hair Lace",
  "Synthetic Ponytails": "Synthetic Ponytails",
  "Table Decoration & Accessories": "Table Decoration & Accessories",
  "Table Linens": "Table Linens",
  "Table Tennis": "Table Tennis",
  "Tap Dance": "Tap Dance",
  "Tapered jeans": "Tapered Jeans",
  "Tapestries": "Tapestries",
  "Tattoo & Body Art": "Tattoo & Body Art",
  "Tattoo Grips": "Tattoo Grips",
  "Tattoo Inks": "Tattoo Inks",
  "Tattoo Kits": "Tattoo Kits",
  "Tattoo Machines": "Tattoo Machines",
  "Tattoo Needles": "Tattoo Needles",
  "Tattoo Power Supplies": "Tattoo Power Supplies",
  "Teeth Whitening Instrument": "Teeth Whitening Instrument",
  "Temperature Humidity Instruments": "Temperature Humidity Instruments",
  "Temperature Sensor": "Temperature Sensor",
  "Tennis": "Tennis",
  "Terrarium Bedding, Sands & Substrates": "Terrarium Bedding, Sands & Substrates",
  "Terrarium Bowls": "Terrarium Bowls",
  "Terrarium Heat Lamps & Mats": "Terrarium Heat Lamps & Mats",
  "Test Tube": "Test Tube",
  "Theodolites": "Theodolites",
  "Thermal Underwear": "Thermal Underwear",
  "Thread Bracelet": "Thread Bracelet",
  "Tie Clips & Cufflinks": "Tie Clips & Cufflinks",
  "Ties": "Ties",
  "Tig Welders": "TIG Welders",
  "Tights": "Tights",
  "Tire Repair Tools": "Tire Repair Tools",
  "Tires": "Tires",
  "Titanium Frames": "Titanium Frames",
  "Tools": "Tools",
  "Tools & Industrial": "Tools & Industrial",
  "Toothbrushes Head": "Toothbrushes Head",
  "Top Hats": "Top Hats",
  "Tops": "Tops",
  "Toupee": "Toupee",
  "Towel": "Towel",
  "Toy Balls": "Toy Balls",
  "Toy Cameras": "Toy Cameras",
  "Toy Guns": "Toy Guns",
  "Toy Musical Instrument": "Toy Musical Instrument",
  "Toy Sports": "Toy Sports",
  "ToyS": "Toys",
  "Toys": "Toys",
  "Toys & Games": "Toys & Games",
  "Training Head Kit": "Training Head Kit",
  "Trampolines": "Trampolines",
  "Transformer Robot": "Transformer Robot",
  "Translator": "Translator",
  "Travel Bag": "Travel Bag",
  "Travel Bags & Luggage": "Travel Bags & Luggage",
  "Travel Wallets": "Travel Wallets",
  "Treadmills": "Treadmills",
  "Trench": "Trench",
  "Trendy Claw Clips": "Trendy Claw Clips",
  "Trendy Hair Clips": "Trendy Hair Clips",
  "Trendy Sunglasses": "Trendy Sunglasses",
  "Trendy Wigs": "Trendy Wigs",
  "Turbos, Nitrous & Superchargers": "Turbos, Nitrous & Superchargers",
  "Turning Tool": "Turning Tool",
  "Turtleneck": "Turtleneck",
  "Turtlenecks": "Turtlenecks",
  "U-Part Wigs": "U-Part Wigs",
  "Ukulele": "Ukulele",
  "Ultrasonic Cleaner": "Ultrasonic Cleaner",
  "Ultrasonic Scaler": "Ultrasonic Scaler",
  "Undershirts": "Undershirts",
  "Used Phones": "Used Phones",
  "Utensils": "Utensils",
  "Vacuum Mite Remover": "Vacuum Mite Remover",
  "Valves": "Valves",
  "Vents": "Vents",
  "Vest": "Vest",
  "Vests & Waistcoats": "Vests & Waistcoats",
  "Video Game Consoles": "Video Game Consoles",
  "Video Intercom": "Video Intercom",
  "Video Surveillance": "Video Surveillance",
  "Waist Chain": "Waist Chain",
  "Waist Cinchers": "Waist Cinchers",
  "Waist Packs": "Waist Packs",
  "Waiter Uniforms": "Waiter Uniforms",
  "Waiting Chairs": "Waiting Chairs",
  "Walkers": "Walkers",
  "Walkie Talkie": "Walkie Talkie",
  "Walkie Talkie Accessories": "Walkie Talkie Accessories",
  "Wall Panels": "Wall Panels",
  "Wallet & ID Holder": "Wallet & ID Holder",
  "Wallpapers": "Wallpapers",
  "Warm Boots": "Warm Boots",
  "Washed leans": "Washed Jeans",
  "Watch Cases": "Watch Cases",
  "Watch Winders": "Watch Winders",
  "Watchbands": "Watchbands",
  "Watches": "Watches",
  "Water Dispenser": "Water Dispenser",
  "Water Filters": "Water Filters",
  "Water Filtration": "Water Filtration",
  "Water Guns, Blasters & Soakers": "Water Guns, Blasters & Soakers",
  "Water Play Equipment": "Water Play Equipment",
  "Water Purifier": "Water Purifier",
  "Watering & lrrigation": "Watering & Irrigation",
  "Waterproof Backpack": "Waterproof Backpack",
  "Waterproof Wall Sticker": "Waterproof Wall Sticker",
  "Wax Heater": "Wax Heater",
  "Wear Parts": "Wear Parts",
  "Wedding Accessories": "Wedding Accessories",
  "Wedding Dress": "Wedding Dress",
  "Wedding Dresses": "Wedding Dresses",
  "Wedding Party Dress": "Wedding Party Dress",
  "Wedge Heel": "Wedge Heel",
  "Weight Benches": "Weight Benches",
  "Welding Equipment": "Welding Equipment",
  "Wheel Parts": "Wheel Parts",
  "Wheels & Flight Joysticks": "Wheels & Flight Joysticks",
  "Wig Stands": "Wig Stands",
  "Wigs": "Wigs",
  "Wildlife Camera": "Wildlife Camera",
  "Winches": "Winches",
  "Window Door Sensor": "Window Door Sensor",
  "Window Foils & Solar Protection": "Window Foils & Solar Protection",
  "Windshield Wipers": "Windshield Wipers",
  "Winter Home Shoes": "Winter Home Shoes",
  "Winter Socks": "Winter Socks",
  "Winter Warm Sleepwear": "Winter Warm Sleepwear",
  "Wiring Accessories": "Wiring Accessories",
  "Wok": "Wok",
  "Womens Belts": "Women's Belts",
  "Womens Boots": "Women's Boots",
  "Womens Casual Shoes": "Women's Casual Shoes",
  "Womens Clothing": "Women's Clothing",
  "Womens Fold Wallet": "Women's Fold Wallet",
  "Womens Necklace": "Women's Necklace",
  "Womens Pants": "Women's Pants",
  "Womens Sandals & Slippers": "Women's Sandals & Slippers",
  "Womens Sunglasses": "Women's Sunglasses",
  "Wooden Blocks": "Wooden Blocks",
  "Wool & Blends Coats": "Wool & Blends Coats",
  "Work & Safety Shoes": "Work & Safety Shoes",
  "Work Wear & Uniforms": "Work Wear & Uniforms",
  "Workplace Safety Supplies": "Workplace Safety Supplies",
  "Writing & Correction Supplies": "Writing & Correction Supplies",
  "Writing Pad": "Writing Pad",
  "Yoyo": "Yo-Yo",
  "Zipper Bag": "Zipper Bag",
  "Phone is not bind": "Phone is not bind",
  "English": "English",
  "Portuguese": "Portuguese",
  "Arabic": "Arabic",
  "Supplier Team": "Supplier Team",
  "Hosting": "Hosting",

  "Upload file header line error": "Upload file header line error",
  "Data is empty": "Data is empty",
  "ResetPassword": "ResetPassword",
  "Accesses": "Accesses",
  "Client Name": "Client Name",
  "Initial password": "Initial password",
  "Store type": "Store type",
  "Store URL": "Store URL",
  "Alias Name": "Alias Name",
  "Token": "Token",
  "Secret key": "Secret key",
  "Reauthorization": "Reauthorization",
  "Clients": "Clients",
  "Adm access": "Adm access",

  "REGISTER": "REGISTER",
  "Please enter your email address": "Please enter your email address",
  "Please input password": "Please input password",
  "Slide to get your CAPTCHA": "Slide to get your CAPTCHA",
  "Please fill in email address as your username": "Please fill in email address as your username",
  "Captcha": "Captcha",
  "Please fill in the CAPTCHA you received": "Please fill in the CAPTCHA you received",
  "Please set your password": "Please set your password",
  "Password confirm": "Password confirm",
  "Please fill in the name": "Please fill in the name",
  "Mobile": "Mobile",
  "Please Select": "Please Select",
  "Please set your mobile": "Please set your mobile",
  "Invitation Code": "Invitation Code",
  "Please confirm your code": "Please confirm your code",
  "CREATE AN ACCOUNT": "CREATE AN ACCOUNT",
  "Already had an account?": "Already had an account?",

  "Change password": "Change password",
  "Please fill in your email address": "Please fill in your email address",
  "Please set your new password": "Please set your new password",
  "Please confirm your new password": "Please confirm your new password",
  "New password": "New password",
  "Confirm password must be filled in": "Confirm password must be filled in",
  "Mobile must be filled in": "Mobile must be filled in",
  "The password and confirm password must be the same": "The password and confirm password must be the same",
  "Please select the country first": "Please select the country first",
  "Please fill in the mobile": "Please fill in the mobile",
  "pre-order item inventory": "pre-order item inventory",
  "packing inventory": "packing inventory",

  "Recharge Application": "Recharge Application",
  "View History": "View History",
  "Recharge Records": "Recharge Records",
  "Payment-link Request": "Payment-link Request",
  "Please select the payment method first": "Please select the payment method first",
  "Please fill in the amount.": "Please fill in the amount.",

  "Channel": "Channel",
  "Top-up Request": "Top-up Request",
  "Upload Evidence": "Upload Evidence",
  "Evidence": "Evidence",
  "createdAt": "CreatedAt",
  "updatedAt": "UpdatedAt",
  "Too many pictures upload!": "Too many pictures upload!",
  "Put payment evidence": "Put payment evidence",
  "Pay difference for order": "Pay difference for order",
  "Pay for CPF checking": "Pay for CPF checking",
  "Add bonus": "Add bonus",
  "Pay for other reason": "Pay for other reason",
  "Please fill the reason": "Please fill the reason",

  "Wait for payment link": "Wait for payment link",
  "Wait for payment evidence": "Wait for payment evidence",
  "Wait for review": "Wait for review",
  "Evidence Pass": "Evidence Pass",
  "Evidence Reject": "Evidence Reject",
  "Ticket Done": "Ticket Done",
  "Closed": "Closed",

  "Wholesale": "Wholesale",
  "Wholesale Products": "Products",
  "Wholesale Favorites": "Favorites",
  "Wholesale Cart": "Cart",
  "Wholesale Orders": "Orders",
  "Add to cart": "Add to cart",
  "Cart": "Cart",

  "BatchRestore": "BatchRestore",
  "RestoreALL": "RestoreAll",
}
